import {
  ACCESS,
  ADDRESS_BUILDING,
  ADDRESS_CITY,
  ADDRESS_COORDINATES,
  ADDRESS_COUNTRY,
  ADDRESS_POST_CODE,
  ADDRESS_STATE,
  ADDRESS_STREET,
  ADMINS,
  AIR,
  ARCTIC_TRUCK,
  ASSET_CATEGORY,
  AUTHENTICATION_GOOGLE,
  AUTHENTICATION_MICROSOFT,
  AUTHENTICATION_SETUP,
  AUTHENTICATION_TYPE,
  BOARD_MEMBER_CATEGORY,
  BOARD_MEMBER_NAME,
  BOARD_MEMBER_PROFESSION,
  BUSINESS_UNIT_TYPE,
  CAN_VIEW,
  CATEGORY,
  CODE,
  COMMENT_LOGICAL,
  COMMENT_MANUFACTURE,
  COMMENT_SERVICE,
  COMMENT_TASK,
  COMMUNITY_GROUP_NAME,
  COMPANY_LOGO,
  CONNECTION_ID,
  CONNECTION_TYPE,
  CONTACT_EMAIL,
  CONTACT_NAME,
  COUNTRY,
  CRITICALITY_FROM_DOWNSTREAM_WASTE,
  CRITICALITY_RATING,
  CURRENCY,
  CURRENT_PASSWORD,
  DATA_SET_UPLOAD_FILE,
  DATE_CLOSED,
  DATE_OPENED,
  DEPARTMENT,
  DESCRIPTION,
  DISCLOSURE,
  DISTANCE,
  DURATION_OF_INVESTMENT,
  EMAIL,
  EMPLOYEE_REPRESENTATIVE_NAME,
  END_DATE,
  EQUITY,
  EQUITY_SHAREHOLDING,
  ESTIMATED,
  EU_TAXONOMY_CODE,
  FILTER_BY_STATUS,
  FINANCIAL_CONTROL,
  FINISHED_GOOD_STOCK_AMOUNT,
  FINISHED_GOOD_STOCK_AMOUNT_CURRENCY,
  FIRST_NAME,
  FROM_NAME,
  FROM_TYPE,
  FROM_UNIT_ID,
  GEO_TYPE_PREFIX,
  GROSS_MARGIN_ROLLING_AMOUNT,
  GROSS_MARGIN_ROLLING_CURRENCY,
  GROSS_MARGIN_ROLLING_PERCENTS,
  HEADINGS_COLOR_1,
  HEADINGS_COLOR_2,
  ID,
  ID_FROM,
  ID_LOGICAL,
  ID_MANUFACTURE,
  ID_SERVICE,
  ID_SUPPLIER,
  ID_TO_LOGICAL,
  ID_TO_MANUFACTURE,
  ID_TO_SERVICE,
  ID_TO_SUPPLIER,
  IMPACT_STATUS,
  INDUSTRY_CODE,
  INTERNAL_LIAISON,
  INTERNAL_LIAISON_EMAIL,
  INVESTOR,
  IRO_CATEGORY,
  IRO_DESCRIPTION,
  LANGUAGE,
  LANGUAGES,
  LAST_NAME,
  LEGAL_NAME,
  MANUFACTURE_CONNECTION_TYPE,
  MEDIA_ORGANISATION_NAME,
  MFA_APP,
  MFA_SMS,
  MONETARY_VALUES,
  MONETARY_VOLUMES,
  NACE_CODE,
  NACE_SECTION,
  NAME,
  NET_BOOK,
  NET_BOOK_CURRENCY,
  NGO_CONTACT_EMAIL,
  NGO_CONTACT_NAME,
  NGO_NAME,
  NUMBER_OF_EMPLOYEES,
  OLD_ORG_PATH,
  ORDER_KEY,
  ORDER_TYPE,
  ORG_PATH,
  ORG_TYPE_PREFIX,
  OWNED_LEASED,
  OWNERSHIP,
  OWNERSHIP_PERCENTAGE,
  PARTNER_LOGO,
  PASSWORD,
  PHONE,
  PILLAR_ID,
  PILLAR_MODULES,
  PILLARS,
  POSITION_ON_VALUE_CHAINS,
  PRIMARY_COLOR,
  PRIORITY_RATING,
  PRODUCT_CATEGORY_ID,
  PRODUCT_TYPE,
  PROFIT,
  PROFIT_CENTER_IDS,
  PROFIT_CENTER_LINKS,
  PROFIT_CENTRE_NAME,
  PROFIT_CENTRE_UNIQUE_IDENTIFIER,
  PURCHASE_VOLUME,
  QUANTITY,
  RAIL,
  REASON,
  RELATE_TO,
  RELATE_TO_MA,
  RELEVANCE_TO_COMPANY,
  RELIANCE_ON_FREE_NATURAL_RESOURCES,
  RELIANCE_ON_FREE_SOCIAL_RESOURCES,
  REPEAT_NEW_PASSWORD,
  REPORTING_FRAMEWORK,
  REPRESENTATION_CATEGORY,
  REPRESENTATIVE_NAME,
  REQUIRED_BY,
  RESPONDENT_TYPE,
  REVENUE_ROLLING_AMOUNT,
  REVENUE_ROLLING_CURRENCY,
  REVENUE_ROLLING_PERCENTS,
  RIGID_TRUCK,
  ROLE,
  SEA,
  SEARCH,
  SECONDARY_COLOR,
  SECTOR,
  SECTOR_CODE,
  SEER_COMPETITOR,
  SELECT_ALL,
  SELECT_ITEM,
  SELECTED_ITEMS,
  SHARE_CATEGORY,
  SHOW_ARCHIVED,
  SIZE_MAX,
  SIZE_MIN,
  SMS_CODE,
  SORT,
  SOURCING_CONNECTIONS,
  SOURCING_KIND,
  SPECIFIC_SENSITIVITY,
  SSO,
  STANDARDS,
  START_DATE,
  STATUS,
  STOCK_TICKER,
  SUBTITLE_COLOR,
  SUPPLIER_LINKS,
  SUPPLIERS_EXPENSES,
  TASK_ASSIGNED_TO,
  TASK_DESCRIPTION,
  TASK_DURATION,
  TASK_END_DATE,
  TASK_NAME,
  TASK_PRIORITY,
  TASK_RELATE_TO,
  TASK_START_DATE,
  TOPIC,
  TRUCK,
  TYPE,
  TYPE_OF_SERVICE_PROVIDER,
  UNIQUE_IDENTIFIER,
  UNIT_CURRENCY,
  UNIT_CURRENCY_VALUES,
  UNIT_MONETARY_VOLUMES,
  UPSTREAM_TIER,
  VALUE_CHAIN_LIST,
  VALUE_CHAIN_MAPS,
  VALUE_CHAIN_SECTION,
  VAN,
  VERIFICATION_CODE,
  VOLUME_QTY,
  VOLUME_QTY_UNIT,
  WEBSITE,
} from 'constants/formFields';
import {
  ALPHANUMERIC_AND_NUMBER_REGEX, ALPHANUMERIC_REGEX, ALPHANUMERIC_SPACES_SPECIAL_CHARTERS_REGEX,
  COMPANY_NAME_MAX_LENGTH, COMPANY_NAME_MIN_LENGTH, CONNECTION_COMMENT_MAX_LENGTH,
  CONNECTION_COMMENT_MIN_LENGTH, DATA_SETS_NAME_MAX_LENGTH,
  DATA_SETS_NAME_MIN_LENGTH, DESCRIPTION_LENGTH, DISABLING_REASON_MIN_LENGTH, INTEGER_NUMBER_REGEX,
  NAME_MAX_LENGTH,
  NAME_MIN_LENGTH,
  TASK_DESCRIPTION_MIN_LENGTH,
} from 'constants/general';
import i18next from 'i18next';
import * as yup from 'yup';

import {
  BUSINESS_UNIT_TYPE_REQUIRED_VALUE,
} from '../constants/dataSets';
import {
  AFFECTED_PERIOD,
  AFFECTED_PERIOD_UNIT,
  COMPANY_NAME, PRODUCTIVITY_IMPACT, QUESTION, QUESTION_SOURCE_TYPE, QUESTION_TYPE, SOURCE,
  UNIT_IDS,
} from '../constants/formFields';
import {
  createAddressFieldValidation,
  createCountryValidation,
  createEuTaxonomyValidation,
  createLabelValueObjectSchema,
  createNaceSectionValidation,
  createNotEmptyObjectTest,
  createObjectShapeValidation,
  createPostCodeValidation,
  createStandardObjectValidation,
  createStateValidation,
  createStringFieldValidation,
} from './validationHelpers';

import type {
  TOrders, TPillarAccessTypes, TStatus,
  TUserPillarAccessTypes, TUserStatus,
} from 'constants/interfaces';
import type { ParsedCountry } from 'react-international-phone/dist/types';

export const companiesListSchema = yup.object({
  [SEARCH]: yup.string(),
  [STATUS]: yup.object().shape({
    label: yup.string().required(),
    value: yup.string().required(),
  }).default(undefined),
  [SORT]: yup.object().shape({
    [ORDER_KEY]: yup.string().required(),
    [ORDER_TYPE]: yup.string<TOrders>().required(),
  }),
});
export type TCompaniesListSchema = yup.InferType<typeof companiesListSchema>;

export const valueChainListSchema = yup.object({
  [SEARCH]: yup.string(),
  [STATUS]: yup.array().of(yup.string()),
  [SORT]: yup.object().shape({
    [ORDER_KEY]: yup.string().required(),
    [ORDER_TYPE]: yup.string<TOrders>().required(),
  }),
});
export type TValueChainMapListSchema = yup.InferType<typeof valueChainListSchema>;

export const companyInfoSchema = yup.object({
  [NAME]: yup.string().min(COMPANY_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('common.name'), length: COMPANY_NAME_MIN_LENGTH },
  )).max(COMPANY_NAME_MAX_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('common.name'), length: COMPANY_NAME_MAX_LENGTH },
  )).trim()
    .matches(ALPHANUMERIC_SPACES_SPECIAL_CHARTERS_REGEX, i18next.t('errors.nameContainLettersAndSpecialSymbols'))
    .required(i18next.t('errors.nameRequired')),
  [TYPE]: yup.object().shape({
    label: yup.string().required(),
    value: yup.string().required(),
  }).default(undefined)
    .required(i18next.t('errors.typeRequired')),
  [DESCRIPTION]: yup.string().max(DESCRIPTION_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('common.description'), length: DESCRIPTION_LENGTH },
  )),
  [CURRENCY]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).default(undefined)
    .required(i18next.t('errors.typeRequired')),
});
export type TCompanyInfoSchema = yup.InferType<typeof companyInfoSchema>;

export const companyMultilingualSchema = yup.object({
  [LANGUAGES]: yup.array().of(yup.string().required()).min(1).required(),
});
export type TCompanyMultilingualSchema = yup.InferType<typeof companyMultilingualSchema>;

export const firstLastNameSchema = yup.object({
  [FIRST_NAME]: yup.string().min(NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('common.firstName'), length: NAME_MIN_LENGTH },
  )).max(NAME_MAX_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('common.firstName'), length: NAME_MAX_LENGTH },
  )).required(i18next.t('errors.firstNameRequired'))
    .transform(
      (value) => value.trim(),
    )
    .matches(ALPHANUMERIC_REGEX, i18next.t('errors.nameContainLettersAndHyphens'))
    .trim(),

  [LAST_NAME]: yup.string().min(NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('common.lastName'), length: NAME_MIN_LENGTH },
  )).max(NAME_MAX_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('common.lastName'), length: NAME_MAX_LENGTH },
  )).required(i18next.t('errors.lastNameRequired'))
    .transform(
      (value) => value.trim(),
    )
    .matches(ALPHANUMERIC_REGEX, i18next.t('errors.nameContainLettersAndHyphens'))
    .trim(),
});

export const companyAdminSchema = yup.object({
  [ADMINS]: yup.array().of(
    firstLastNameSchema.shape({
      [ID]: yup.number(),
      [STATUS]: yup.string<TUserStatus>(),
      [EMAIL]: yup.string().email(i18next.t('errors.emailNotValid')).required(i18next.t('errors.emailNotValid')),
    }),
  ).required(),
});
export type TCompanyAdminSchema = yup.InferType<typeof companyAdminSchema>;

export const companyUIConfigurationSchema = yup.object({
  [COMPANY_LOGO]: yup.mixed<File | string>().required(i18next.t('errors.companyLogoRequired')),
  [PARTNER_LOGO]: yup.mixed<File | string>(),
  [PRIMARY_COLOR]: yup.string().required(),
  [SECONDARY_COLOR]: yup.string().required(),
  [HEADINGS_COLOR_1]: yup.string().required(),
  [HEADINGS_COLOR_2]: yup.string().required(),
  [SUBTITLE_COLOR]: yup.string().required(),
});
export type TCompanyUiConfigurationSchema = yup.InferType<typeof companyUIConfigurationSchema>;

export const companyPermissionsSchema = yup.object({
  [PILLARS]: yup.array().of(yup.object({
    [ID]: yup.number().required(),
    [NAME]: yup.string(),
    [CAN_VIEW]: yup.boolean().required(),
    [PILLAR_MODULES]: yup.array().of(yup.object({
      [ID]: yup.number().required(),
      [NAME]: yup.string(),
      [PILLAR_ID]: yup.number().required(),
      [ACCESS]: yup.string<TPillarAccessTypes>().required(),
    })).required(),
  })).required(),
});
export type TCompanyPermissionsSchema = yup.InferType<typeof companyPermissionsSchema>;

export const companySecuritySchema = yup.object({
  [SSO]: yup.string<TStatus>().required(),
  [MFA_APP]: yup.string<TStatus>().required(),
  [MFA_SMS]: yup.string<TStatus>().required(),
});
export type TCompanySecuritySchema = yup.InferType<typeof companySecuritySchema>;

export const authenticationSchema = yup.object({
  [AUTHENTICATION_TYPE]: yup.string().required().min(1).required(),
});

export const authenticationSetupSchema = yup.object({
  [AUTHENTICATION_SETUP]: yup.string().oneOf([AUTHENTICATION_GOOGLE, AUTHENTICATION_MICROSOFT]),
});

export type TAuthenticationSetupSchema = yup.InferType<typeof authenticationSetupSchema>;

export const verificationSmsSchema = yup.object({
  [SMS_CODE]: yup.string().required().transform(
    (value) => value?.replace(/[^\d]/g, ''),
  ).min(6),
});

export const verificationCodeSchema = yup.object({
  [VERIFICATION_CODE]: yup.string().required().transform(
    (value) => value?.replace(/[^\d]/g, ''),
  ).min(6),
});

export const forgotPasswordSchema = yup.object({
  [EMAIL]: yup.string().required().email(),
});

export const loginSchema = yup.object({
  [EMAIL]: yup.string().required().email(),
  [PASSWORD]: yup.string().required().max(128)
    .trim(),
});

export const newPasswordSchema = yup.object({
  [PASSWORD]: yup.string().required().min(12)
    .max(128)
    .trim(),
  [REPEAT_NEW_PASSWORD]: yup.string().required().min(12)
    .max(128)
    .oneOf([yup.ref(PASSWORD)], i18next.t('errors.passwordMismatch'))
    .trim(),
});

export const personalInfoSchema = firstLastNameSchema.shape({
  [EMAIL]: yup.string().email(i18next.t('errors.emailNotValid')).required(),
});

export type TPersonalInfoSchema = yup.InferType<typeof personalInfoSchema>;

export const profilePasswordSchema = yup.object({
  [CURRENT_PASSWORD]: yup.string().required().min(12)
    .max(128)
    .trim(),
  [PASSWORD]: yup.string().required().min(12)
    .max(128)
    .trim(),
  [REPEAT_NEW_PASSWORD]: yup.string().required().min(12)
    .max(128)
    .oneOf([yup.ref(PASSWORD)], i18next.t('errors.passwordMismatch'))
    .trim(),
});

export const profileLanguageSchema = yup.object({
  [LANGUAGE]: yup.string().required(),
});

export type TProfileLanguageSchema = yup.InferType<typeof profileLanguageSchema>;

export const userManagementSchema = yup.object({
  [SEARCH]: yup.string(),
  [FILTER_BY_STATUS]: yup.object({ value: yup.string(), label: yup.string() }),
  [SORT]: yup.object().shape({
    [ORDER_KEY]: yup.string(),
    [ORDER_TYPE]: yup.string<TOrders>(),
  }),
});

export type TUserManagementSchema = yup.InferType<typeof userManagementSchema>;

export const createNewUserSchema = firstLastNameSchema.shape({
  [ROLE]: yup.object().shape({
    label: yup.string().required(),
    value: yup.string().required(),
  }).default(undefined).required(),
  [EMAIL]: yup.string().email(i18next.t('errors.emailNotValid')).required(),
});

export type TCreateNewUserSchema = yup.InferType<typeof createNewUserSchema>;

export const userPermissionsSchema = yup.object({
  [PILLARS]: yup.array().of(yup.object({
    [ID]: yup.number().required(),
    [NAME]: yup.string(),
    [PILLAR_MODULES]: yup.array().of(yup.object({
      [ID]: yup.number().required(),
      [NAME]: yup.string(),
      [PILLAR_ID]: yup.number().required(),
      [ACCESS]: yup.string<TUserPillarAccessTypes | TPillarAccessTypes>(),
    })).required(),
  })).required(),
});

export type TUserPermissionsSchema = yup.InferType<typeof userPermissionsSchema>;

export const deactivationSchema = yup.object({
  [REASON]: yup.string()
    .min(DISABLING_REASON_MIN_LENGTH)
    .max(DESCRIPTION_LENGTH)
    .trim()
    .required(i18next.t('errors.reasonRequired')),
});

export const renameValueChainSchema = yup.object({
  [NAME]: yup.string()
    .min(DISABLING_REASON_MIN_LENGTH)
    .max(NAME_MAX_LENGTH)
    .trim()
    .required(i18next.t('errors.nameRequired')),
});

export type TDeactivationSchema = yup.InferType<typeof deactivationSchema>;
export type TRenameValueChainSchema = yup.InferType<typeof renameValueChainSchema>;

export const verificationPhoneSchema = ({ parsedCountry }: { parsedCountry?: ParsedCountry }) => {
  const { format } = parsedCountry as { format: string } || '';
  const phoneLength = format?.match?.(/\./g)?.length || 10;
  const countryLength = parsedCountry?.dialCode?.length || 1;
  const minPhoneLength = phoneLength + countryLength + 1;

  return yup.object({
    [PHONE]: yup.string().required().transform(
      (value) => `+${value?.replace(/[^\d]/g, '')}`,
    ).min(minPhoneLength),
  });
};

export const usersListSchema = yup.object({
  [SEARCH]: yup.string(),
});
export type TUsersListSchema = yup.InferType<typeof usersListSchema>;

export const dataSetUploadSchema = yup.object({
  [DATA_SET_UPLOAD_FILE]: yup.mixed<File | string>().required(),
});
export type TDataSetUploadSchema = yup.InferType<typeof dataSetUploadSchema>;

export const dataSetsListSchema = yup.object({
  [SEARCH]: yup.string(),
  [FILTER_BY_STATUS]: yup.object({ value: yup.string(), label: yup.string() }),
  [SHOW_ARCHIVED]: yup.boolean(),
  [SORT]: yup.object().shape({
    [ORDER_KEY]: yup.string(),
    [ORDER_TYPE]: yup.string<TOrders>(),
  }),
  [SELECTED_ITEMS]: yup.array().of(yup.number().required()).required(),
  [SELECT_ALL]: yup.string(),
  [ORG_TYPE_PREFIX]: yup.string(),
  [GEO_TYPE_PREFIX]: yup.string(),
});

export type TDataSetsListSchema = yup.InferType<typeof dataSetsListSchema>;

export const createProfitCentreSchema = yup.object({
  [PROFIT_CENTRE_NAME]: yup.string().min(COMPANY_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('profitCentres.createProfitCentre.fields.name'), length: COMPANY_NAME_MIN_LENGTH },
  )).max(DATA_SETS_NAME_MAX_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('profitCentres.createProfitCentre.fields.name'), length: DATA_SETS_NAME_MAX_LENGTH },
  )).required(i18next.t('errors.requiredField', { name: i18next.t('profitCentres.createProfitCentre.fields.name') }))
    .transform((value) => value.trim())
    .matches(ALPHANUMERIC_SPACES_SPECIAL_CHARTERS_REGEX, i18next.t('errors.nameContainLettersAndSpecialSymbols'))
    .trim(),

  [PROFIT_CENTRE_UNIQUE_IDENTIFIER]: yup.string().min(COMPANY_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('profitCentres.createProfitCentre.fields.uniqueIdentifier'), length: COMPANY_NAME_MIN_LENGTH },
  )).max(DATA_SETS_NAME_MAX_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('profitCentres.createProfitCentre.fields.uniqueIdentifier'), length: DATA_SETS_NAME_MAX_LENGTH },
  )).required(i18next.t('errors.requiredField', {
    name: i18next.t('profitCentres.createProfitCentre.fields.uniqueIdentifier'),
  }))
    .matches(ALPHANUMERIC_AND_NUMBER_REGEX, i18next.t('errors.nameContainLettersAndNumbers')),
  [VALUE_CHAIN_SECTION]: createStandardObjectValidation('common.valueChainPosition'),
  [VALUE_CHAIN_LIST]: createStandardObjectValidation('common.valueChainCategory'),
  [OWNERSHIP]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).test(createNotEmptyObjectTest('profitCentres.createProfitCentre.fields.ownership')).required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t('profitCentres.createProfitCentre.fields.ownership', { interpolation: { escapeValue: false } }),
      interpolation: { escapeValue: false },
    },
  )),
  [EQUITY_SHAREHOLDING]: yup.string().test(
    'max-percentage',
    i18next.t('errors.maxNumberPercent', {
      name: i18next.t('profitCentres.createProfitCentre.fields.equityShareholdingCurrency'),
      max: 100,
    }),
    (value) => {
      if (!value || value === '') return true;
      const numValue = Number(value);
      return !Number.isNaN(numValue) && numValue >= 0 && numValue <= 100;
    },
  ),
  [FINANCIAL_CONTROL]: yup.string().test(
    'max-percentage',
    i18next.t('errors.maxNumberPercent', {
      name: i18next.t('profitCentres.createProfitCentre.fields.financialControlCurrency'),
      max: 100,
    }),
    (value) => {
      if (!value || value === '') return true;
      const numValue = Number(value);
      return !Number.isNaN(numValue) && numValue >= 0 && numValue <= 100;
    },
  ),
  [NUMBER_OF_EMPLOYEES]: yup.string(),
  [DATE_OPENED]: yup.string().required(i18next.t(
    'errors.requiredField',
    { name: i18next.t('profitCentres.createProfitCentre.fields.dateOpened') },
  )),
  [DATE_CLOSED]: yup.string(),
  [NACE_SECTION]: createNaceSectionValidation('ownOperations.fields.sector'),
  [NACE_CODE]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).nullable(),
  [EU_TAXONOMY_CODE]: createEuTaxonomyValidation('ownOperations.fields.taxonomy'),

  [START_DATE]: yup.string().required(i18next.t(
    'errors.requiredField',
    { name: i18next.t('profitCentres.createProfitCentre.fields.startDate') },
  )),
  [END_DATE]: yup.string().required(i18next.t(
    'errors.requiredField',
    { name: i18next.t('profitCentres.createProfitCentre.fields.endDate') },
  )),

  [NET_BOOK]: yup.string(),

  [NET_BOOK_CURRENCY]: yup.string(),

  [REVENUE_ROLLING_AMOUNT]: yup.string().min(DATA_SETS_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('profitCentres.createProfitCentre.fields.actualRevenue'), length: DATA_SETS_NAME_MIN_LENGTH },
  )),

  [REVENUE_ROLLING_CURRENCY]: yup.string(),

  [GROSS_MARGIN_ROLLING_AMOUNT]: yup.string().min(DATA_SETS_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('profitCentres.createProfitCentre.fields.actualGross'), length: DATA_SETS_NAME_MIN_LENGTH },
  )),

  [GROSS_MARGIN_ROLLING_CURRENCY]: yup.string(),

  [FINISHED_GOOD_STOCK_AMOUNT]: yup.string().min(DATA_SETS_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('profitCentres.createProfitCentre.fields.stock'), length: DATA_SETS_NAME_MIN_LENGTH },
  )),

  [FINISHED_GOOD_STOCK_AMOUNT_CURRENCY]: yup.string(),

  [REVENUE_ROLLING_PERCENTS]: yup.string(),

  [GROSS_MARGIN_ROLLING_PERCENTS]: yup.string(),

  [ORG_PATH]: yup.string().min(COMPANY_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('ownOperations.fields.orgPath'), length: COMPANY_NAME_MIN_LENGTH },
  )).max(DESCRIPTION_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('ownOperations.fields.orgPath'), length: DESCRIPTION_LENGTH },
  )).required(i18next.t('errors.requiredField', { name: i18next.t('ownOperations.fields.orgPath') }))
    .transform(
      (value) => value.trim(),
    )
    .trim(),
  [OLD_ORG_PATH]: yup.string(),
  [ADDRESS_COUNTRY]: createCountryValidation('profitCentres.createProfitCentre.fields.country'),

  [ADDRESS_STATE]: createStateValidation('profitCentres.createProfitCentre.fields.state'),

  [ADDRESS_POST_CODE]: createPostCodeValidation(),

  [ADDRESS_CITY]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).nullable(),

  [ADDRESS_STREET]: createStringFieldValidation({
    fieldNameKey: 'customers.fields.street',
  }),

  [ADDRESS_BUILDING]: createStringFieldValidation({
    fieldNameKey: 'customers.fields.building',
  }),

  [ADDRESS_COORDINATES]: createStringFieldValidation({
    fieldNameKey: 'customers.fields.coordinates',
  }),
});

export const getCreateProfitCentreSchema = (orgStructureData?: unknown[]) => {
  const hasNoFirstLayer = orgStructureData === undefined || (orgStructureData?.length ?? 0) === 0;
  if (!hasNoFirstLayer) return createProfitCentreSchema;
  return createProfitCentreSchema.shape({
    [ORG_PATH]: yup.string().ensure().trim(),
    [NET_BOOK]: yup.string().required(i18next.t('errors.requiredField', {
      name: i18next.t('profitCentres.createProfitCentre.fields.relatedBalanceSheetAssets'),
    })),
  });
};

export type TCreateProfitCentreSchema = yup.InferType<typeof createProfitCentreSchema>;

export const createOwnOperationsSchema = yup.object({
  [NAME]: yup.string().min(COMPANY_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('ownOperations.fields.name'), length: COMPANY_NAME_MIN_LENGTH },
  )).max(DATA_SETS_NAME_MAX_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('ownOperations.fields.name'), length: DATA_SETS_NAME_MAX_LENGTH },
  )).required(i18next.t('errors.requiredField', { name: i18next.t('ownOperations.fields.name') }))
    .transform(
      (value) => value.trim(),
    )
    .trim(),
  [ORG_PATH]: yup.string().trim(),
  [UNIQUE_IDENTIFIER]: yup.string().min(COMPANY_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('ownOperations.fields.uniqueIdentifier'), length: COMPANY_NAME_MIN_LENGTH },
  )).max(DATA_SETS_NAME_MAX_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('ownOperations.fields.uniqueIdentifier'), length: DATA_SETS_NAME_MAX_LENGTH },
  )).required(i18next.t('errors.requiredField', { name: i18next.t('ownOperations.fields.uniqueIdentifier') }))
    .matches(ALPHANUMERIC_AND_NUMBER_REGEX, i18next.t('errors.nameContainLettersAndNumbers')),
  [LEGAL_NAME]: yup.string().min(COMPANY_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('ownOperations.fields.legalEntity'), length: COMPANY_NAME_MIN_LENGTH },
  )).max(DATA_SETS_NAME_MAX_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('ownOperations.fields.legalEntity'), length: DATA_SETS_NAME_MAX_LENGTH },
  )).required(i18next.t('errors.requiredField', { name: i18next.t('ownOperations.fields.legalEntity') }))
    .transform(
      (value) => value.trim(),
    )
    .trim(),
  [PROFIT_CENTER_IDS]: yup.array().of(yup.object().shape({
    label: yup.string(),
    value: yup.string().required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t('ownOperations.fields.profitCentre', { interpolation: { escapeValue: false } }),
        interpolation: { escapeValue: false },
      },
    )),
  })).min(1, i18next.t(
    'errors.requiredField',
    {
      name: i18next.t('ownOperations.fields.profitCentre', { interpolation: { escapeValue: false } }),
      interpolation: { escapeValue: false },
    },
  )),
  [VALUE_CHAIN_SECTION]: createStandardObjectValidation('common.valueChainPosition'),
  [VALUE_CHAIN_LIST]: createStandardObjectValidation('common.valueChainCategory'),
  [OWNERSHIP]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).test(createNotEmptyObjectTest('ownOperations.fields.ownership')).default(undefined)
    .required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t('ownOperations.fields.ownership', { interpolation: { escapeValue: false } }),
        interpolation: { escapeValue: false },
      },
    )),
  [EQUITY_SHAREHOLDING]: yup.string().test(
    'max-percentage',
    i18next.t('errors.maxNumberPercent', {
      name: i18next.t('ownOperations.fields.equityShareholding'),
      max: 100,
    }),
    (value) => {
      if (!value || value === '') return true;
      const numValue = Number(value);
      return !Number.isNaN(numValue) && numValue >= 0 && numValue <= 100;
    },
  ),
  [FINANCIAL_CONTROL]: yup.string().test(
    'max-percentage',
    i18next.t('errors.maxNumberPercent', {
      name: i18next.t('ownOperations.fields.financialControl'),
      max: 100,
    }),
    (value) => {
      if (!value || value === '') return true;
      const numValue = Number(value);
      return !Number.isNaN(numValue) && numValue >= 0 && numValue <= 100;
    },
  ),
  [BUSINESS_UNIT_TYPE]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }),
  [ASSET_CATEGORY]: yup.array().of(yup.object().shape({
    label: yup.string(),
    value: yup.string().required(i18next.t(
      'errors.requiredField',
      { name: i18next.t('ownOperations.fields.assetCategory') },
    )),
  })).min(1, i18next.t(
    'errors.requiredField',
    { name: i18next.t('ownOperations.fields.assetCategory') },
  )),
  [OWNED_LEASED]: yup.object().shape({
    label: yup.string(),
    value: yup.string().required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t('ownOperations.fields.owned', { interpolation: { escapeValue: false } }),
        interpolation: { escapeValue: false },
      },
    )),
    divisions: yup.array(),
  }),
  [NUMBER_OF_EMPLOYEES]: yup.string(),
  [DATE_OPENED]: yup.string().required(i18next.t(
    'errors.requiredField',
    { name: i18next.t('ownOperations.fields.dateOpened') },
  )),
  [DATE_CLOSED]: yup.string(),
  [START_DATE]: yup.string().required(i18next.t(
    'errors.requiredField',
    { name: i18next.t('profitCentres.createProfitCentre.fields.startDate') },
  )),
  [END_DATE]: yup.string().required(i18next.t(
    'errors.requiredField',
    { name: i18next.t('profitCentres.createProfitCentre.fields.endDate') },
  )),
  [NACE_SECTION]: createNaceSectionValidation('ownOperations.fields.sector'),
  [NACE_CODE]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).nullable(),
  [EU_TAXONOMY_CODE]: createEuTaxonomyValidation('ownOperations.fields.taxonomy'),
  [NET_BOOK]: yup.string().min(DATA_SETS_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('ownOperations.fields.netBook'), length: DATA_SETS_NAME_MIN_LENGTH },
  )),
  [NET_BOOK_CURRENCY]: yup.string(),
  [ADDRESS_COUNTRY]: createAddressFieldValidation('country'),
  [ADDRESS_STATE]: createAddressFieldValidation('state'),
  [ADDRESS_POST_CODE]: createPostCodeValidation()
    .when(BUSINESS_UNIT_TYPE, {
      is: (businessUnitType: { value: string }) => businessUnitType?.value === BUSINESS_UNIT_TYPE_REQUIRED_VALUE,
      then: () => yup
        .string()
        .trim()
        .required(
          i18next.t('errors.requiredField', {
            name: i18next.t('profitCentres.createProfitCentre.fields.post'),
          }),
        ),
    }),
  [ADDRESS_CITY]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).nullable(),
  [ADDRESS_STREET]: yup.string()
    .max(DATA_SETS_NAME_MAX_LENGTH, i18next.t(
      'errors.maxCharactersLength',
      { name: i18next.t('customers.fields.building'), length: DATA_SETS_NAME_MAX_LENGTH },
    ))
    .test(
      'Min length when not empty value',
      i18next.t(
        'errors.minCharactersLength',
        { name: i18next.t('customers.fields.building'), length: DATA_SETS_NAME_MIN_LENGTH },
      ),
      (value) => !value || value.length >= DATA_SETS_NAME_MIN_LENGTH,
    )
    .transform((value) => value.trim())
    .trim(),
  [ADDRESS_BUILDING]: yup.string()
    .when(BUSINESS_UNIT_TYPE, {
      is: (businessUnitType: { value: string }) => businessUnitType?.value === BUSINESS_UNIT_TYPE_REQUIRED_VALUE,
      then: () => yup.string().min(DATA_SETS_NAME_MIN_LENGTH, i18next.t(
        'errors.minCharactersLength',
        { name: i18next.t('profitCentres.createProfitCentre.fields.building'), length: DATA_SETS_NAME_MIN_LENGTH },
      )).max(DATA_SETS_NAME_MAX_LENGTH, i18next.t(
        'errors.maxCharactersLength',
        { name: i18next.t('profitCentres.createProfitCentre.fields.building'), length: DATA_SETS_NAME_MAX_LENGTH },
      )).required(i18next.t(
        'errors.requiredField',
        { name: i18next.t('profitCentres.createProfitCentre.fields.building') },
      ))
        .transform(
          (value) => value.trim(),
        )
        .trim(),
    }),
  [ADDRESS_COORDINATES]: yup.string().test(
    'Min length when not empty value',
    i18next.t(
      'errors.minCharactersLength',
      { name: i18next.t('profitCentres.createProfitCentre.fields.coordinates'), length: DATA_SETS_NAME_MIN_LENGTH },
    ),
    (value) => !value || value.length >= DATA_SETS_NAME_MIN_LENGTH,
  ).transform((value) => value.trim()).trim(),
});

export type TCreateOperationsSchema = yup.InferType<typeof createOwnOperationsSchema>;

export const profitCenterLinkSchema = yup.object({
  profitCenterId: yup.string().required(i18next.t('errors.requiredField', {
    name: i18next.t('ownOperations.fields.profitCentre'),
  })),
  startDate: yup.string().required(i18next.t('errors.requiredField', {
    name: i18next.t('suppliers.fields.startDate'),
  })),
  endDate: yup.string().required(i18next.t('errors.requiredField', {
    name: i18next.t('suppliers.fields.endDate'),
  })),
  totalCost: yup.string().required(i18next.t('errors.requiredField', {
    name: i18next.t('suppliers.fields.keySuppliers'),
  })),
  percentOfTotalCost: yup.number()
    .transform((value, originalValue) => {
      // Handle empty strings and null/undefined values
      if (originalValue === '' || originalValue === null || originalValue === undefined) {
        return undefined;
      }
      return value;
    })
    .required(i18next.t('errors.requiredField', {
      name: i18next.t('suppliers.fields.keySuppliersInPercentage', { interpolation: { escapeValue: false } }),
      interpolation: { escapeValue: false },
    }))
    .typeError(i18next.t('errors.requiredField', {
      name: i18next.t('suppliers.fields.keySuppliersInPercentage', { interpolation: { escapeValue: false } }),
      interpolation: { escapeValue: false },
    }))
    .min(0, i18next.t('errors.minNumber', {
      name: i18next.t('suppliers.fields.keySuppliersInPercentage', { interpolation: { escapeValue: false } }),
      interpolation: { escapeValue: false },
      min: 0,
    }))
    .max(100, i18next.t('errors.maxNumberPercent', {
      name: i18next.t('suppliers.fields.keySuppliersInPercentage', { interpolation: { escapeValue: false } }),
      interpolation: { escapeValue: false },
      max: 100,
    })),
});

export type TProfitCenterLinkSchema = yup.InferType<typeof profitCenterLinkSchema>;

export const createSupplierSchema = yup.object({
  [NAME]: yup.string().min(COMPANY_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('suppliers.fields.supplierName'), length: COMPANY_NAME_MIN_LENGTH },
  )).max(DATA_SETS_NAME_MAX_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('suppliers.fields.supplierName'), length: DATA_SETS_NAME_MAX_LENGTH },
  )).required(i18next.t('errors.requiredField', { name: i18next.t('suppliers.fields.supplierName') }))
    .transform(
      (value) => value.trim(),
    )
    .trim(),
  [CODE]: yup.string().min(COMPANY_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('suppliers.fields.supplierCode'), length: COMPANY_NAME_MIN_LENGTH },
  )).max(DATA_SETS_NAME_MAX_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('suppliers.fields.supplierCode'), length: DATA_SETS_NAME_MAX_LENGTH },
  )).matches(ALPHANUMERIC_AND_NUMBER_REGEX, i18next.t('errors.nameContainLettersAndNumbers'))
    .required(i18next.t('errors.requiredField', { name: i18next.t('suppliers.fields.supplierCode') })),
  [UNIQUE_IDENTIFIER]: yup.string().min(COMPANY_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('suppliers.fields.uniqueIdentifier'), length: COMPANY_NAME_MIN_LENGTH },
  )).max(DATA_SETS_NAME_MAX_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('suppliers.fields.uniqueIdentifier'), length: DATA_SETS_NAME_MAX_LENGTH },
  )).required(i18next.t('errors.requiredField', { name: i18next.t('suppliers.fields.uniqueIdentifier') }))
    .matches(ALPHANUMERIC_AND_NUMBER_REGEX, i18next.t('errors.nameContainLettersAndNumbers')),
  [PROFIT_CENTER_LINKS]: yup.array()
    .of(profitCenterLinkSchema)
    .min(1, i18next.t('errors.requiredField', {
      name: i18next.t('common.profitCentre'),
    }))
    .required(i18next.t('errors.requiredField', {
      name: i18next.t('common.profitCentre'),
    })),
  [VALUE_CHAIN_SECTION]: createStandardObjectValidation('common.valueChainPosition'),
  [VALUE_CHAIN_LIST]: createStandardObjectValidation('common.valueChainCategory'),
  [UPSTREAM_TIER]: yup.object().shape({
    label: yup.string(),
    value: yup.string().required(i18next.t(
      'errors.requiredField',
      { name: i18next.t('suppliers.fields.upstreamTier') },
    )),
  }),
  [OWNERSHIP]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).test(createNotEmptyObjectTest('suppliers.fields.ownership')).default(undefined)
    .required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t('suppliers.fields.ownership', { interpolation: { escapeValue: false } }),
        interpolation: { escapeValue: false },
      },
    )),
  [EQUITY_SHAREHOLDING]: yup.string().test(
    'max-percentage',
    i18next.t('errors.maxNumberPercent', {
      name: i18next.t('suppliers.fields.equityShareholding'),
      max: 100,
    }),
    (value) => {
      if (!value || value === '') return true;
      const numValue = Number(value);
      return !Number.isNaN(numValue) && numValue >= 0 && numValue <= 100;
    },
  ),
  [FINANCIAL_CONTROL]: yup.string().test(
    'max-percentage',
    i18next.t('errors.maxNumberPercent', {
      name: i18next.t('suppliers.fields.financialControl'),
      max: 100,
    }),
    (value) => {
      if (!value || value === '') return true;
      const numValue = Number(value);
      return !Number.isNaN(numValue) && numValue >= 0 && numValue <= 100;
    },
  ),
  [BUSINESS_UNIT_TYPE]: yup.object().shape({
    label: yup.string(),
    value: yup.string().required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t('suppliers.fields.physicalOrLogical', { interpolation: { escapeValue: false } }),
        interpolation: { escapeValue: false },
      },
    )),
  }),
  [DATE_OPENED]: yup.string().required(i18next.t(
    'errors.requiredField',
    { name: i18next.t('suppliers.fields.dateOpened') },
  )),
  [DATE_CLOSED]: yup.string(),
  [NACE_SECTION]: createNaceSectionValidation('suppliers.fields.sector'),
  [NACE_CODE]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).nullable(),
  [EU_TAXONOMY_CODE]: createEuTaxonomyValidation('suppliers.fields.taxonomy'),
  [ADDRESS_COUNTRY]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).test('not-empty', i18next.t('errors.requiredField', {
    name: i18next.t('profitCentres.createProfitCentre.fields.country', { interpolation: { escapeValue: false } }),
    interpolation: { escapeValue: false },
  }), (obj) => {
    if (!obj) return false;
    return !(obj.value === '' && obj.label === '');
  }).default(undefined)
    .required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t('profitCentres.createProfitCentre.fields.country', { interpolation: { escapeValue: false } }),
        interpolation: { escapeValue: false },
      },
    )),
  [ADDRESS_STATE]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).nullable(),
  [ADDRESS_POST_CODE]: yup.string()
    .trim()
    .max(
      DATA_SETS_NAME_MAX_LENGTH,
      i18next.t('errors.maxCharactersLength', {
        name: i18next.t('suppliers.fields.post'),
        length: DATA_SETS_NAME_MAX_LENGTH,
      }),
    ),
  [ADDRESS_CITY]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).nullable(),
  [ADDRESS_STREET]: yup.string().max(DATA_SETS_NAME_MAX_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('customers.fields.street'), length: DATA_SETS_NAME_MAX_LENGTH },
  )).test(
    'Min length when not empty value',
    i18next.t(
      'errors.minCharactersLength',
      { name: i18next.t('customers.fields.street'), length: DATA_SETS_NAME_MIN_LENGTH },
    ),
    (value) => !value || value.length >= DATA_SETS_NAME_MIN_LENGTH,
  ).transform(
    (value) => value.trim(),
  )
    .trim(),
  [ADDRESS_BUILDING]: yup.string().max(DATA_SETS_NAME_MAX_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('customers.fields.building'), length: DATA_SETS_NAME_MAX_LENGTH },
  )).test(
    'Min length when not empty value',
    i18next.t(
      'errors.minCharactersLength',
      { name: i18next.t('customers.fields.building'), length: DATA_SETS_NAME_MIN_LENGTH },
    ),
    (value) => !value || value.length >= DATA_SETS_NAME_MIN_LENGTH,
  ).transform(
    (value) => value.trim(),
  )
    .trim(),
  [ADDRESS_COORDINATES]: yup.string().test(
    'Min length when not empty value',
    i18next.t(
      'errors.minCharactersLength',
      { name: i18next.t('customers.fields.coordinates'), length: DATA_SETS_NAME_MIN_LENGTH },
    ),
    (value) => !value || value.length >= DATA_SETS_NAME_MIN_LENGTH,
  ).transform(
    (value) => value.trim(),
  )
    .trim(),
});

export type TCreateSupplierSchema = yup.InferType<typeof createSupplierSchema>;

export const profitCenterLinkProductSchema = yup.object({
  profitCenterId: yup.string().required(i18next.t('errors.requiredField', {
    name: i18next.t('ownOperations.fields.profitCentre'),
  })),
  startDate: yup.string().required(i18next.t('errors.requiredField', {
    name: i18next.t('products.fields.startDate'),
  })),
  endDate: yup.string().required(i18next.t('errors.requiredField', {
    name: i18next.t('products.fields.endDate'),
  })),
  totalCost: yup.string().required(i18next.t('errors.requiredField', {
    name: i18next.t('products.fields.suppliersTier1'),
  })),
  percentOfTotalCost: yup.number()
    .transform((value, originalValue) => {
      // Handle empty strings and null/undefined values
      if (originalValue === '' || originalValue === null || originalValue === undefined) {
        return undefined;
      }
      return value;
    })
    .required(i18next.t('errors.requiredField', {
      name: i18next.t('products.fields.suppliersTier1InPercentage', { interpolation: { escapeValue: false } }),
      interpolation: { escapeValue: false },
    }))
    .typeError(i18next.t('errors.requiredField', {
      name: i18next.t('products.fields.suppliersTier1InPercentage', { interpolation: { escapeValue: false } }),
      interpolation: { escapeValue: false },
    }))
    .min(0, i18next.t('errors.minNumber', {
      name: i18next.t('products.fields.suppliersTier1InPercentage', { interpolation: { escapeValue: false } }),
      interpolation: { escapeValue: false },
      min: 0,
    }))
    .max(100, i18next.t('errors.maxNumberPercent', {
      name: i18next.t('products.fields.suppliersTier1InPercentage', { interpolation: { escapeValue: false } }),
      interpolation: { escapeValue: false },
      max: 100,
    })),
  expectedGrowthDecline: yup.number()
    .transform((value, originalValue) => {
      if (originalValue === '' || originalValue === null || originalValue === undefined) {
        return undefined;
      }
      return value;
    })
    .required(i18next.t('errors.requiredField', {
      name: i18next.t('products.fields.expectedGrowthDecline', { interpolation: { escapeValue: false } }),
      interpolation: { escapeValue: false },
    }))
    .typeError(i18next.t('errors.requiredField', {
      name: i18next.t('products.fields.expectedGrowthDecline', { interpolation: { escapeValue: false } }),
      interpolation: { escapeValue: false },
    }))
    .min(0, i18next.t('errors.minNumber', {
      name: i18next.t('products.fields.expectedGrowthDecline', { interpolation: { escapeValue: false } }),
      interpolation: { escapeValue: false },
      min: 0,
    }))
    .max(100, i18next.t('errors.maxNumberPercent', {
      name: i18next.t('products.fields.expectedGrowthDecline', { interpolation: { escapeValue: false } }),
      interpolation: { escapeValue: false },
      max: 100,
    })),
});

// The editable body of a goods-supplier connection, shared by the two forms that write these
// edges: the board's connection modal keeps them at the form root, while a record modal keeps an
// array of connections and repeats them per item.
const goodsSupplierConnectionShape = {
  [AIR]: yup.boolean(),
  [SEA]: yup.boolean(),
  [RAIL]: yup.boolean(),
  [VAN]: yup.boolean(),
  [TRUCK]: yup.boolean(),
  [RIGID_TRUCK]: yup.boolean(),
  [ARCTIC_TRUCK]: yup.boolean(),
  [DISTANCE]: yup.string()
    .test(
      'minLength',
      i18next.t('errors.minCharactersLength', {
        name: i18next.t('valueChainMap.minCharactersLength'),
        length: NAME_MIN_LENGTH,
      }),
      (value) => !value || value.length >= NAME_MIN_LENGTH,
    )
    .test(
      'maxLength',
      i18next.t('errors.maxCharactersLength', {
        name: i18next.t('valueChainMap.maxCharactersLength'),
        length: COMPANY_NAME_MAX_LENGTH,
      }),
      (value) => !value || value.length <= COMPANY_NAME_MAX_LENGTH,
    ),
  [MONETARY_VOLUMES]: yup.string()
    .test(
      'maxLength',
      i18next.t('errors.maxCharactersLength', {
        name: i18next.t('valueChainMap.monetaryVolumes'),
        length: 64,
      }),
      (value) => !value || value.toString().length <= 64,
    ),
  // `.optional()` is type-level only — the `.when()` below governs validation either way. It is
  // here because a manufacture row in the joined sourcing list never fills these in, so the
  // inferred row type has to admit their absence.
  [UNIT_MONETARY_VOLUMES]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).optional().when(MONETARY_VOLUMES, {
    is: (value: string) => value && value !== '',
    then: () => yup.object().shape({
      label: yup.string().required(i18next.t(
        'errors.requiredField',
        { name: i18next.t('valueChainMap.unitMonetaryVolumes') },
      )),
      value: yup.string().required(i18next.t(
        'errors.requiredField',
        { name: i18next.t('valueChainMap.unitMonetaryVolumes') },
      )),
    }),
    otherwise: () => yup.object().nullable().default(undefined),
  }),
  [QUANTITY]: yup.string()
    .test(
      'maxLength',
      i18next.t('errors.maxCharactersLength', {
        name: i18next.t('valueChainMap.monetaryVolumes'),
        length: 64,
      }),
      (value) => !value || value.toString().length <= 64,
    ),
  [UNIT_CURRENCY]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).optional().when(QUANTITY, {
    is: (value: string) => value && value !== '',
    then: () => yup.object().shape({
      label: yup.string().required(i18next.t(
        'errors.requiredField',
        { name: i18next.t('valueChainMap.unitCurrency') },
      )),
      value: yup.string().required(i18next.t(
        'errors.requiredField',
        { name: i18next.t('valueChainMap.unitCurrency') },
      )),
    }),
    otherwise: () => yup.object().nullable().default(undefined),
  }),
};

const connectionIdentityShape = {
  // Absent on an item the user has just added — that is what makes the backend create the
  // edge rather than update one.
  [CONNECTION_ID]: yup.number(),
  // Chosen once, when the connection is added: the backend rejects a changed source on an
  // existing edge, so the picker is only offered while adding.
  [FROM_UNIT_ID]: yup.number().required(),
  // Carried for display only, and dropped before the item is sent.
  [FROM_NAME]: yup.string(),
  [FROM_TYPE]: yup.string(),
};

// One row of the joined sourcing list. Both kinds' fields live in one shape because a row only
// fills in the half belonging to its `kind` — the goods-supplier fields are conditionally
// required on each other, so a manufacture row leaving them empty never trips those conditions.
export const sourcingConnectionSchema = yup.object({
  ...goodsSupplierConnectionShape,
  ...connectionIdentityShape,
  [SOURCING_KIND]: yup.string().required(),
  // Absent on a goods-supplier row, so it has to be genuinely optional rather than an empty
  // object the inferred type would then demand on every row.
  [MANUFACTURE_CONNECTION_TYPE]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).optional(),
  // Bounds mirror the backend's `MinLength(3) + MaxLength(256)`, which applies to every
  // connection comment. Both skip an empty value: no comment is valid, a two-character one is not.
  [COMMENT_MANUFACTURE]: yup.string()
    .test(
      'minLength',
      i18next.t('errors.minCharactersLength', {
        name: i18next.t('valueChainMap.comment'),
        length: CONNECTION_COMMENT_MIN_LENGTH,
      }),
      (value) => !value || value.trim().length >= CONNECTION_COMMENT_MIN_LENGTH,
    )
    .test(
      'maxLength',
      i18next.t('errors.maxCharactersLength', {
        name: i18next.t('valueChainMap.comment'),
        length: CONNECTION_COMMENT_MAX_LENGTH,
      }),
      (value) => !value || value.length <= CONNECTION_COMMENT_MAX_LENGTH,
    ),
});

export type TSourcingConnectionSchema = yup.InferType<typeof sourcingConnectionSchema>;

export const createProductSchema = yup.object({
  [PRODUCT_CATEGORY_ID]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }),
  [PRODUCT_TYPE]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }),
  [NAME]: yup.string().min(COMPANY_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('products.fields.productName'), length: COMPANY_NAME_MIN_LENGTH },
  )).max(DATA_SETS_NAME_MAX_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('products.fields.productName'), length: DATA_SETS_NAME_MAX_LENGTH },
  )).required(i18next.t('errors.requiredField', { name: i18next.t('products.fields.productName') }))
    .transform(
      (value) => value.trim(),
    )
    .trim(),
  [CODE]: yup.string().min(COMPANY_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('products.fields.productCode'), length: COMPANY_NAME_MIN_LENGTH },
  )).max(DATA_SETS_NAME_MAX_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('products.fields.productCode'), length: DATA_SETS_NAME_MAX_LENGTH },
  )).matches(ALPHANUMERIC_AND_NUMBER_REGEX, i18next.t('errors.nameContainLettersAndNumbers'))
    .required(i18next.t('errors.requiredField', { name: i18next.t('products.fields.productCode') })),
  [UNIQUE_IDENTIFIER]: yup.string().min(COMPANY_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('products.fields.uniqueIdentifier'), length: COMPANY_NAME_MIN_LENGTH },
  )).max(DATA_SETS_NAME_MAX_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('products.fields.uniqueIdentifier'), length: DATA_SETS_NAME_MAX_LENGTH },
  )).required(i18next.t('errors.requiredField', { name: i18next.t('products.fields.uniqueIdentifier') }))
    .matches(ALPHANUMERIC_AND_NUMBER_REGEX, i18next.t('errors.nameContainLettersAndNumbers')),
  // The picker only offers units of the type the section allows, so an entry can never be
  // partially filled and needs no conditional validation.
  [SUPPLIER_LINKS]: yup.array().of(
    yup.object().shape({
      relationUID: yup.string().required(),
      relationType: yup.string().required(),
    }),
  ),
  [DATE_OPENED]: yup.string().required(i18next.t(
    'errors.requiredField',
    { name: i18next.t('products.fields.dateTo') },
  )),
  [DATE_CLOSED]: yup.string(),
  [VOLUME_QTY]: yup.string().required(i18next.t(
    'errors.requiredField',
    { name: i18next.t('products.fields.volume') },
  )),
  [VOLUME_QTY_UNIT]: yup.object().shape({
    label: yup.string(),
    value: yup.string().required(i18next.t(
      'errors.requiredField',
      { name: i18next.t('products.fields.volumeUnit') },
    )),
  }),
  [RELIANCE_ON_FREE_NATURAL_RESOURCES]: yup.array().of(yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  })),
  [RELIANCE_ON_FREE_SOCIAL_RESOURCES]: yup.array().of(yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  })),
  [CRITICALITY_RATING]: yup.object().shape({
    label: yup.string(),
    value: yup.string().required(i18next.t(
      'errors.requiredField',
      { name: i18next.t('products.fields.rating') },
    )),
  }),
  [UPSTREAM_TIER]: yup.object().shape({
    label: yup.string(),
    value: yup.string().required(i18next.t(
      'errors.requiredField',
      { name: i18next.t('suppliers.fields.upstreamTier') },
    )),
  }),
  [CRITICALITY_FROM_DOWNSTREAM_WASTE]: yup.string().test(
    'max-percentage',
    i18next.t('errors.maxNumberPercent', {
      name: i18next.t('products.fields.circularityPercentage'),
      max: 100,
    }),
    (value) => {
      if (!value || value === '') return true;
      const numValue = Number(value);
      return !Number.isNaN(numValue) && numValue >= 0 && numValue <= 100;
    },
  ),
  [PROFIT_CENTER_LINKS]: yup.array()
    .of(profitCenterLinkProductSchema)
    .min(1, i18next.t('errors.requiredField', {
      name: i18next.t('common.profitCentre'),
    }))
    .required(i18next.t('errors.requiredField', {
      name: i18next.t('common.profitCentre'),
    })),
  [SOURCING_CONNECTIONS]: yup.array().of(sourcingConnectionSchema),
  [VALUE_CHAIN_SECTION]: createStandardObjectValidation('common.valueChainPosition'),
  [VALUE_CHAIN_LIST]: createStandardObjectValidation('common.valueChainCategory'),
});

export const createProductModalSchema = createProductSchema;

export type TCreateProductSchema = yup.InferType<typeof createProductSchema>;

export const createCustomerSchema = yup.object({
  [NAME]: yup.string().min(COMPANY_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('customers.fields.customerName'), length: COMPANY_NAME_MIN_LENGTH },
  )).max(DATA_SETS_NAME_MAX_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('customers.fields.customerName'), length: DATA_SETS_NAME_MAX_LENGTH },
  )).required(i18next.t('errors.requiredField', { name: i18next.t('suppliers.fields.customerName') }))
    .transform(
      (value) => value.trim(),
    )
    .trim(),
  [CODE]: yup.string().min(COMPANY_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('customers.fields.customerCode'), length: COMPANY_NAME_MIN_LENGTH },
  )).max(DATA_SETS_NAME_MAX_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('customers.fields.customerCode'), length: DATA_SETS_NAME_MAX_LENGTH },
  )).matches(ALPHANUMERIC_AND_NUMBER_REGEX, i18next.t('errors.nameContainLettersAndNumbers'))
    .required(i18next.t('errors.requiredField', { name: i18next.t('customers.fields.customerCode') })),
  [UNIQUE_IDENTIFIER]: yup.string().min(COMPANY_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('customers.fields.uniqueIdentifier'), length: COMPANY_NAME_MIN_LENGTH },
  )).max(DATA_SETS_NAME_MAX_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('customers.fields.uniqueIdentifier'), length: DATA_SETS_NAME_MAX_LENGTH },
  )).required(i18next.t('errors.requiredField', { name: i18next.t('customers.fields.uniqueIdentifier') }))
    .matches(ALPHANUMERIC_AND_NUMBER_REGEX, i18next.t('errors.nameContainLettersAndNumbers')),
  [VALUE_CHAIN_SECTION]: createStandardObjectValidation('common.valueChainPosition'),
  [VALUE_CHAIN_LIST]: createStandardObjectValidation('common.valueChainCategory'),
  [OWNERSHIP]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).test(createNotEmptyObjectTest('customers.fields.ownership')).default(undefined)
    .required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t('customers.fields.ownership', { interpolation: { escapeValue: false } }),
        interpolation: { escapeValue: false },
      },
    )),
  [PROFIT_CENTER_LINKS]: yup.array()
    .of(profitCenterLinkSchema)
    .min(1, i18next.t('errors.requiredField', {
      name: i18next.t('common.profitCentre'),
    }))
    .required(i18next.t('errors.requiredField', {
      name: i18next.t('common.profitCentre'),
    })),
  [EQUITY_SHAREHOLDING]: yup.string().test(
    'max-percentage',
    i18next.t('errors.maxNumberPercent', {
      name: i18next.t('customers.fields.equityShareholding'),
      max: 100,
    }),
    (value) => {
      if (!value || value === '') return true;
      const numValue = Number(value);
      return !Number.isNaN(numValue) && numValue >= 0 && numValue <= 100;
    },
  ),
  [FINANCIAL_CONTROL]: yup.string().test(
    'max-percentage',
    i18next.t('errors.maxNumberPercent', {
      name: i18next.t('customers.fields.financialControl'),
      max: 100,
    }),
    (value) => {
      if (!value || value === '') return true;
      const numValue = Number(value);
      return !Number.isNaN(numValue) && numValue >= 0 && numValue <= 100;
    },
  ),
  [BUSINESS_UNIT_TYPE]: yup.object().shape({
    label: yup.string(),
    value: yup.string().required(i18next.t(
      'errors.requiredField',
      { name: i18next.t('customers.fields.physicalOrLogical'), interpolation: { escapeValue: false } },
    )),
  }),
  [DATE_OPENED]: yup.string().required(i18next.t(
    'errors.requiredField',
    { name: i18next.t('customers.fields.dateOpened') },
  )),
  [DATE_CLOSED]: yup.string(),
  [PRIORITY_RATING]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }),
  [NACE_SECTION]: yup.object().shape({
    label: yup.string(),
    value: yup.string().required(i18next.t(
      'errors.requiredField',
      { name: i18next.t('customers.fields.sector') },
    )),
    divisions: yup.array(),
  }),
  [NACE_CODE]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).nullable(),
  [EU_TAXONOMY_CODE]: yup.string().test(
    'Min length when not empty value',
    i18next.t(
      'errors.minCharactersLength',
      { name: i18next.t('suppliers.fields.taxonomy'), length: DATA_SETS_NAME_MIN_LENGTH },
    ),
    (value) => !value || value.length >= DATA_SETS_NAME_MIN_LENGTH,
  ).max(DATA_SETS_NAME_MAX_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('suppliers.fields.taxonomy'), length: DATA_SETS_NAME_MAX_LENGTH },
  ))
    .transform(
      (value) => value.trim(),
    )
    .trim(),
  [ADDRESS_COUNTRY]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).test('not-empty', i18next.t('errors.requiredField', {
    name: i18next.t('profitCentres.createProfitCentre.fields.country', { interpolation: { escapeValue: false } }),
    interpolation: { escapeValue: false },
  }), (obj) => {
    if (!obj) return false;
    return !(obj.value === '' && obj.label === '');
  }).default(undefined)
    .required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t('profitCentres.createProfitCentre.fields.country', { interpolation: { escapeValue: false } }),
        interpolation: { escapeValue: false },
      },
    )),
  [ADDRESS_STATE]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).nullable(),
  [ADDRESS_POST_CODE]: yup.string()
    .trim()
    .max(
      DATA_SETS_NAME_MAX_LENGTH,
      i18next.t('errors.maxCharactersLength', {
        name: i18next.t('suppliers.fields.post'),
        length: DATA_SETS_NAME_MAX_LENGTH,
      }),
    ),
  [ADDRESS_CITY]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).nullable(),
  [ADDRESS_STREET]: yup.string().max(DATA_SETS_NAME_MAX_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('customers.fields.street'), length: DATA_SETS_NAME_MAX_LENGTH },
  )).test(
    'Min length when not empty value',
    i18next.t(
      'errors.minCharactersLength',
      { name: i18next.t('customers.fields.street'), length: DATA_SETS_NAME_MIN_LENGTH },
    ),
    (value) => !value || value.length >= DATA_SETS_NAME_MIN_LENGTH,
  ).transform(
    (value) => value.trim(),
  )
    .trim(),
  [ADDRESS_BUILDING]: yup.string().max(DATA_SETS_NAME_MAX_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('customers.fields.building'), length: DATA_SETS_NAME_MAX_LENGTH },
  )).test(
    'Min length when not empty value',
    i18next.t(
      'errors.minCharactersLength',
      { name: i18next.t('customers.fields.building'), length: DATA_SETS_NAME_MIN_LENGTH },
    ),
    (value) => !value || value.length >= DATA_SETS_NAME_MIN_LENGTH,
  ).transform(
    (value) => value.trim(),
  )
    .trim(),
  [ADDRESS_COORDINATES]: yup.string().test(
    'Min length when not empty value',
    i18next.t(
      'errors.minCharactersLength',
      { name: i18next.t('customers.fields.coordinates'), length: DATA_SETS_NAME_MIN_LENGTH },
    ),
    (value) => !value || value.length >= DATA_SETS_NAME_MIN_LENGTH,
  ).transform(
    (value) => value.trim(),
  )
    .trim(),
});

export const renameCompanySchema = yup.object({
  [NAME]: yup.string().required(i18next.t('errors.requiredField', { name: i18next.t('common.name') })),
});

export type TCreateCustomerSchema = yup.InferType<typeof createCustomerSchema>;
export type TConnectionVCSchema = yup.InferType<typeof connectionVCSchema>;

export const connectionVCSchema = yup.object({
  [CONNECTION_TYPE]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).nullable().default(undefined),
  [COMMENT_LOGICAL]: yup.string()
    .test(
      'min-length-if-exists',
      i18next.t('errors.minCharactersLength', { name: i18next.t('valueChainMap.minCharactersLength'), length: 3 }),
      (value) => !value || value.length >= 3,
    )
    .max(256, i18next.t(
      'errors.maxCharactersLength',
      { name: i18next.t('valueChainMap.maxCharactersLength'), length: 256 },
    )),
  [COMMENT_SERVICE]: yup.string()
    .test(
      'min-length-if-exists',
      i18next.t('errors.minCharactersLength', { name: i18next.t('valueChainMap.minCharactersLength'), length: 3 }),
      (value) => !value || value.length >= 3,
    )
    .max(256, i18next.t(
      'errors.maxCharactersLength',
      { name: i18next.t('valueChainMap.maxCharactersLength'), length: 256 },
    )),
  [MANUFACTURE_CONNECTION_TYPE]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).nullable().default(undefined),
  [COMMENT_MANUFACTURE]: yup.string()
    .test(
      'min-length-if-exists',
      i18next.t('errors.minCharactersLength', { name: i18next.t('valueChainMap.minCharactersLength'), length: 3 }),
      (value) => !value || value.length >= 3,
    )
    .max(256, i18next.t(
      'errors.maxCharactersLength',
      { name: i18next.t('valueChainMap.maxCharactersLength'), length: 256 },
    )),
  [OWNERSHIP_PERCENTAGE]: yup.string(),
  [TYPE_OF_SERVICE_PROVIDER]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).nullable().default(undefined),
  [MONETARY_VALUES]: yup.string()
    .test(
      'maxLength',
      i18next.t('errors.maxCharactersLength', {
        name: i18next.t('valueChainMap.monetaryValues'),
        length: 9,
      }),
      (value) => !value || value.toString().length <= 9,
    ),
  [UNIT_CURRENCY_VALUES]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).when(MONETARY_VALUES, {
    is: (value: string) => value && value !== '',
    then: () => yup.object().shape({
      label: yup.string().required(i18next.t(
        'errors.requiredField',
        { name: i18next.t('valueChainMap.unitCurrencyValues') },
      )),
      value: yup.string().required(i18next.t(
        'errors.requiredField',
        { name: i18next.t('valueChainMap.unitCurrencyValues') },
      )),
    }),
    otherwise: () => yup.object().nullable().default(undefined),
  }),
  ...goodsSupplierConnectionShape,
  [ID_LOGICAL]: yup.number(),
  [ID_SUPPLIER]: yup.number(),
  [ID_SERVICE]: yup.number(),
  [ID_MANUFACTURE]: yup.number(),
  [ID_TO_LOGICAL]: yup.number(),
  [ID_TO_SUPPLIER]: yup.number(),
  [ID_TO_SERVICE]: yup.number(),
  [ID_TO_MANUFACTURE]: yup.number(),
  [ID_FROM]: yup.number(),
});

export const createTaskFormSchema = yup.object({
  [TASK_NAME]: yup.string().min(COMPANY_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('taskManagement.fields.name'), length: COMPANY_NAME_MIN_LENGTH },
  )).max(NAME_MAX_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('taskManagement.fields.name'), length: NAME_MAX_LENGTH },
  )).required(i18next.t('errors.requiredField', { name: i18next.t('taskManagement.fields.name') }))
    .transform(
      (value) => value.trim(),
    )
    .trim(),
  [TASK_RELATE_TO]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).test('not-empty', i18next.t('errors.requiredField', {
    name: i18next.t('taskManagement.fields.relateTo', { interpolation: { escapeValue: false } }),
    interpolation: { escapeValue: false },
  }), (obj) => {
    if (!obj) return false;
    return !(obj.value === '' && obj.label === '');
  }).default(undefined)
    .required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t('taskManagement.fields.relateTo', { interpolation: { escapeValue: false } }),
        interpolation: { escapeValue: false },
      },
    )),
  [TASK_ASSIGNED_TO]: yup.array().of(yup.object().shape({
    label: yup.string(),
    value: yup.string(),
    position: yup.string(),
    role: yup.string(),
    email: yup.string(),
  })),
  [TASK_DESCRIPTION]: yup.string().max(TASK_DESCRIPTION_MIN_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('taskManagement.fields.description'), length: TASK_DESCRIPTION_MIN_LENGTH },
  )),
  [TASK_START_DATE]: yup.string().nullable(),
  [TASK_END_DATE]: yup.string().nullable(),
  [TASK_DURATION]: yup.string(),
  [TASK_PRIORITY]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).test('not-empty', i18next.t('errors.requiredField', {
    name: i18next.t('taskManagement.fields.priority', { interpolation: { escapeValue: false } }),
    interpolation: { escapeValue: false },
  }), (obj) => {
    if (!obj) return false;
    return !(obj.value === '' && obj.label === '');
  }).default(undefined)
    .required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t('taskManagement.fields.priority', { interpolation: { escapeValue: false } }),
        interpolation: { escapeValue: false },
      },
    )),
});

export type TTaskManagementSchema = yup.InferType<typeof createTaskFormSchema>;

export const dataTaskListSchema = yup.object({
  [SEARCH]: yup.string(),
  [SORT]: yup.object().shape({
    [ORDER_KEY]: yup.string(),
    [ORDER_TYPE]: yup.string<TOrders>(),
  }),
  [RELATE_TO]: yup.array().of(yup.object().shape({
    id: yup.number().required(),
    name: yup.string().required(),
  })),
  [RELATE_TO_MA]: yup.array().of(yup.object().shape({
    id: yup.number().required(),
    name: yup.string().required(),
  })),
  [STATUS]: yup.array().of(yup.string()),
});

export type TDataTaskListSchema = yup.InferType<typeof dataTaskListSchema>;

export const dataTaskCommentSchema = yup.object({
  [COMMENT_TASK]: yup.string(),
});

export type TDataTaskCommentSchema = yup.InferType<typeof dataTaskCommentSchema>;

export const initiateFormSchema = yup.object({
  [NAME]: yup.string().min(COMPANY_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('taskManagement.fields.name'), length: COMPANY_NAME_MIN_LENGTH },
  )).max(NAME_MAX_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('taskManagement.fields.name'), length: NAME_MAX_LENGTH },
  )).required(i18next.t('errors.requiredField', { name: i18next.t('taskManagement.fields.name') }))
    .transform(
      (value) => value.trim(),
    )
    .trim(),
  [DESCRIPTION]: yup.string().max(TASK_DESCRIPTION_MIN_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('taskManagement.fields.description'), length: TASK_DESCRIPTION_MIN_LENGTH },
  )),
  [VALUE_CHAIN_MAPS]: yup.array().of(yup.object().shape({
    id: yup.number(),
    name: yup.string(),
    status: yup.string(),
    createdBy: yup.object().shape({
      id: yup.number(),
      firstName: yup.string(),
      lastName: yup.string(),
    }),
    updatedBy: yup.object().shape({
      id: yup.number(),
      firstName: yup.string(),
      lastName: yup.string(),
    }),
    createdAt: yup.string(),
    updatedAt: yup.string(),
  })),
  [TASK_ASSIGNED_TO]: yup.array().of(yup.object().shape({
    label: yup.string(),
    value: yup.string(),
    position: yup.string(),
    role: yup.string(),
    email: yup.string(),
  })),
  [STANDARDS]: yup.array().of(yup.object().shape({
    label: yup.string(),
    value: yup.number(),
  })),
  [STATUS]: yup.string(),
});

export type TInitiateFormSchema = yup.InferType<typeof initiateFormSchema>;

export const supplierListSchema = yup.object({
  [SEARCH]: yup.string(),
  [SORT]: yup.object().shape({
    [ORDER_KEY]: yup.string(),
    [ORDER_TYPE]: yup.string<TOrders>(),
  }),
  [SELECTED_ITEMS]: yup.array().of(yup.number().required()).required(),
});

export type TSupplierListSchema = yup.InferType<typeof supplierListSchema>;

export const investorCreateSchema = yup.object({
  [INVESTOR]: yup.string().min(COMPANY_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('materialityAssessment.fields.investor'), length: COMPANY_NAME_MIN_LENGTH },
  )).max(DATA_SETS_NAME_MAX_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('materialityAssessment.fields.investor'), length: DATA_SETS_NAME_MAX_LENGTH },
  )).required(i18next.t('errors.requiredField', { name: i18next.t('materialityAssessment.fields.investor') }))
    .transform(
      (value) => value.trim(),
    )
    .trim(),
  [CONTACT_NAME]: yup.string().min(COMPANY_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('materialityAssessment.fields.contactName'), length: COMPANY_NAME_MIN_LENGTH },
  )).max(DATA_SETS_NAME_MAX_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('materialityAssessment.fields.contactName'), length: DATA_SETS_NAME_MAX_LENGTH },
  )).required(i18next.t('errors.requiredField', { name: i18next.t('materialityAssessment.fields.contactName') }))
    .transform(
      (value) => value.trim(),
    )
    .trim(),
  [CONTACT_EMAIL]: yup.string().email(i18next.t('errors.invalidEmail')).required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t(
        'materialityAssessment.fields.contactEmail',
        { interpolation: { escapeValue: false } },
      ),
      interpolation: { escapeValue: false },
    },
  )),
  [EQUITY]: yup.string().required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t(
        'materialityAssessment.fields.equity',
        { interpolation: { escapeValue: false } },
      ),
      interpolation: { escapeValue: false },
    },
  )).test(
    'max-100',
    i18next.t('errors.maxNumberPercent', {
      name: i18next.t('materialityAssessment.fields.equity', { interpolation: { escapeValue: false } }),
      interpolation: { escapeValue: false },
      max: 100,
    }),
    (value) => !value || Number(value) <= 100,
  ),
  [SHARE_CATEGORY]: yup.object().shape({
    label: yup.string().required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t(
          'materialityAssessment.fields.shareCategory',
          { interpolation: { escapeValue: false } },
        ),
        interpolation: { escapeValue: false },
      },
    )),
    value: yup.string().required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t(
          'materialityAssessment.fields.shareCategory',
          { interpolation: { escapeValue: false } },
        ),
        interpolation: { escapeValue: false },
      },
    )),
  }).required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t(
        'materialityAssessment.fields.shareCategory',
        { interpolation: { escapeValue: false } },
      ),
      interpolation: { escapeValue: false },
    },
  )),
  [DURATION_OF_INVESTMENT]: yup.string().required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t(
        'materialityAssessment.fields.durationOfInvestment',
        { interpolation: { escapeValue: false } },
      ),
      interpolation: { escapeValue: false },
    },
  )),
});

export type TInvestorCreateSchema = yup.InferType<typeof investorCreateSchema>;

export const boardCreateSchema = yup.object({
  [BOARD_MEMBER_NAME]: yup.string().min(COMPANY_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('materialityAssessment.fields.boardMemberName'), length: COMPANY_NAME_MIN_LENGTH },
  )).max(DATA_SETS_NAME_MAX_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('materialityAssessment.fields.boardMemberName'), length: DATA_SETS_NAME_MAX_LENGTH },
  )).required(i18next.t('errors.requiredField', { name: i18next.t('materialityAssessment.fields.boardMemberName') }))
    .transform(
      (value) => value.trim(),
    )
    .trim(),
  [CONTACT_EMAIL]: yup.string().email(i18next.t('errors.invalidEmail'))
    .required(i18next.t('errors.requiredField', {
      name: i18next.t('materialityAssessment.fields.contactEmail'),
      interpolation: { escapeValue: false },
    })),
  [CONTACT_NAME]: yup.string()
    .min(COMPANY_NAME_MIN_LENGTH, i18next.t(
      'errors.minCharactersLength',
      { name: i18next.t('materialityAssessment.fields.contactName'), length: COMPANY_NAME_MIN_LENGTH },
    ))
    .max(DATA_SETS_NAME_MAX_LENGTH, i18next.t(
      'errors.maxCharactersLength',
      { name: i18next.t('materialityAssessment.fields.contactName'), length: DATA_SETS_NAME_MAX_LENGTH },
    ))
    .required(i18next.t('errors.requiredField', {
      name: i18next.t('materialityAssessment.fields.contactName'),
      interpolation: { escapeValue: false },
    }))
    .transform((value) => value?.trim())
    .trim(),
  [BOARD_MEMBER_PROFESSION]: yup.object().shape({
    label: yup.string().required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t(
          'materialityAssessment.fields.boardMemberCategory',
          { interpolation: { escapeValue: false } },
        ),
        interpolation: { escapeValue: false },
      },
    )),
    value: yup.string().required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t(
          'materialityAssessment.fields.boardMemberProfession',
          { interpolation: { escapeValue: false } },
        ),
        interpolation: { escapeValue: false },
      },
    )),
  }).required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t(
        'materialityAssessment.fields.boardMemberProfession',
        { interpolation: { escapeValue: false } },
      ),
      interpolation: { escapeValue: false },
    },
  )),
  [BOARD_MEMBER_CATEGORY]: yup.object().shape({
    label: yup.string().required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t(
          'materialityAssessment.fields.boardMemberCategory',
          { interpolation: { escapeValue: false } },
        ),
        interpolation: { escapeValue: false },
      },
    )),
    value: yup.string().required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t(
          'materialityAssessment.fields.boardMemberCategory',
          { interpolation: { escapeValue: false } },
        ),
        interpolation: { escapeValue: false },
      },
    )),
  }).required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t(
        'materialityAssessment.fields.boardMemberCategory',
        { interpolation: { escapeValue: false } },
      ),
      interpolation: { escapeValue: false },
    },
  )),
});

export type TBoardCreateSchema = yup.InferType<typeof boardCreateSchema>;

export const employeesCreateSchema = yup.object({
  [EMPLOYEE_REPRESENTATIVE_NAME]: yup.string().min(COMPANY_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('materialityAssessment.fields.employeeRepresentativeName'), length: COMPANY_NAME_MIN_LENGTH },
  )).max(DATA_SETS_NAME_MAX_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('materialityAssessment.fields.employeeRepresentativeName'), length: DATA_SETS_NAME_MAX_LENGTH },
  )).required(i18next.t('errors.requiredField', { name: i18next.t('materialityAssessment.fields.boardMemberName') }))
    .transform(
      (value) => value.trim(),
    )
    .trim(),
  [CONTACT_EMAIL]: yup.string().email(i18next.t('errors.invalidEmail')).required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t(
        'materialityAssessment.fields.contactEmail',
        { interpolation: { escapeValue: false } },
      ),
      interpolation: { escapeValue: false },
    },
  )),
  [DEPARTMENT]: yup.object().shape({
    label: yup.string().required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t(
          'materialityAssessment.fields.department',
          { interpolation: { escapeValue: false } },
        ),
        interpolation: { escapeValue: false },
      },
    )),
    value: yup.string().required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t(
          'materialityAssessment.fields.department',
          { interpolation: { escapeValue: false } },
        ),
        interpolation: { escapeValue: false },
      },
    )),
  }).required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t(
        'materialityAssessment.fields.department',
        { interpolation: { escapeValue: false } },
      ),
      interpolation: { escapeValue: false },
    },
  )),
  [ROLE]: yup.object().shape({
    label: yup.string().required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t(
          'materialityAssessment.fields.role',
          { interpolation: { escapeValue: false } },
        ),
        interpolation: { escapeValue: false },
      },
    )),
    value: yup.string().required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t(
          'materialityAssessment.fields.role',
          { interpolation: { escapeValue: false } },
        ),
        interpolation: { escapeValue: false },
      },
    )),
  }).required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t(
        'materialityAssessment.fields.role',
        { interpolation: { escapeValue: false } },
      ),
      interpolation: { escapeValue: false },
    },
  )),
});

export type TEmployeesCreateSchema = yup.InferType<typeof employeesCreateSchema>;

export const initiateVCFormSchema = yup.object({
  [SEARCH]: yup.string(),
  [SORT]: yup.object().shape({
    [ORDER_KEY]: yup.string(),
    [ORDER_TYPE]: yup.string<TOrders>(),
  }),
});

export type TInitiateVCFormSchema = yup.InferType<typeof initiateVCFormSchema>;

export const communitiesCreateSchema = yup.object({
  [COMMUNITY_GROUP_NAME]: yup.string().min(COMPANY_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('materialityAssessment.fields.communityGroupName'), length: COMPANY_NAME_MIN_LENGTH },
  )).max(DATA_SETS_NAME_MAX_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('materialityAssessment.fields.communityGroupName'), length: DATA_SETS_NAME_MAX_LENGTH },
  )).required(i18next.t('errors.requiredField', { name: i18next.t('materialityAssessment.fields.communityGroupName') }))
    .transform(
      (value) => value.trim(),
    )
    .trim(),
  [REPRESENTATION_CATEGORY]: yup.object().shape({
    label: yup.string().required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t(
          'materialityAssessment.fields.representationCategory',
          { interpolation: { escapeValue: false } },
        ),
        interpolation: { escapeValue: false },
      },
    )),
    value: yup.string().required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t(
          'materialityAssessment.fields.representationCategory',
          { interpolation: { escapeValue: false } },
        ),
        interpolation: { escapeValue: false },
      },
    )),
  }).required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t(
        'materialityAssessment.fields.representationCategory',
        { interpolation: { escapeValue: false } },
      ),
      interpolation: { escapeValue: false },
    },
  )),
  [REPRESENTATIVE_NAME]: yup.string().min(COMPANY_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('materialityAssessment.fields.representativeName'), length: COMPANY_NAME_MIN_LENGTH },
  )).max(DATA_SETS_NAME_MAX_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('materialityAssessment.fields.representativeName'), length: DATA_SETS_NAME_MAX_LENGTH },
  )).required(i18next.t('errors.requiredField', { name: i18next.t('materialityAssessment.fields.representativeName') }))
    .transform(
      (value) => value.trim(),
    )
    .trim(),
  [CONTACT_EMAIL]: yup.string().email(i18next.t('errors.invalidEmail')).required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t(
        'materialityAssessment.fields.contactEmail',
        { interpolation: { escapeValue: false } },
      ),
      interpolation: { escapeValue: false },
    },
  )),
  [INTERNAL_LIAISON]: yup.string().min(COMPANY_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('materialityAssessment.fields.internalLiaison'), length: COMPANY_NAME_MIN_LENGTH },
  )).max(DATA_SETS_NAME_MAX_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('materialityAssessment.fields.internalLiaison'), length: DATA_SETS_NAME_MAX_LENGTH },
  )).required(i18next.t('errors.requiredField', { name: i18next.t('materialityAssessment.fields.internalLiaison') }))
    .transform(
      (value) => value.trim(),
    )
    .trim(),
  [INTERNAL_LIAISON_EMAIL]: yup.string().email(i18next.t('errors.invalidEmail')).required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t(
        'materialityAssessment.fields.internalLiaisonEmail',
        { interpolation: { escapeValue: false } },
      ),
      interpolation: { escapeValue: false },
    },
  )),
});

export type TCommunitiesCreateSchema = yup.InferType<typeof communitiesCreateSchema>;

export const mediaCreateSchema = yup.object({
  [MEDIA_ORGANISATION_NAME]: yup.string().min(COMPANY_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('materialityAssessment.fields.mediaOrganisationName'), length: COMPANY_NAME_MIN_LENGTH },
  )).max(DATA_SETS_NAME_MAX_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('materialityAssessment.fields.mediaOrganisationName'), length: DATA_SETS_NAME_MAX_LENGTH },
  )).required(i18next.t(
    'errors.requiredField',
    { name: i18next.t('materialityAssessment.fields.mediaOrganisationName') },
  ))
    .transform(
      (value) => value.trim(),
    )
    .trim(),
  [REPRESENTATION_CATEGORY]: yup.object().shape({
    label: yup.string().required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t(
          'materialityAssessment.fields.representationCategory',
          { interpolation: { escapeValue: false } },
        ),
        interpolation: { escapeValue: false },
      },
    )),
    value: yup.string().required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t(
          'materialityAssessment.fields.representationCategory',
          { interpolation: { escapeValue: false } },
        ),
        interpolation: { escapeValue: false },
      },
    )),
  }).required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t(
        'materialityAssessment.fields.representationCategory',
        { interpolation: { escapeValue: false } },
      ),
      interpolation: { escapeValue: false },
    },
  )),
  [RELEVANCE_TO_COMPANY]: yup.string().min(COMPANY_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('materialityAssessment.fields.relevanceToCompany'), length: COMPANY_NAME_MIN_LENGTH },
  )).max(DESCRIPTION_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('materialityAssessment.fields.relevanceToCompany'), length: DESCRIPTION_LENGTH },
  )).required(i18next.t('errors.requiredField', { name: i18next.t('materialityAssessment.fields.relevanceToCompany') }))
    .transform(
      (value) => value.trim(),
    )
    .trim(),
  [CONTACT_NAME]: yup.string().required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t(
        'materialityAssessment.fields.contactName',
        { interpolation: { escapeValue: false } },
      ),
      interpolation: { escapeValue: false },
    },
  )),
  [CONTACT_EMAIL]: yup.string().email(i18next.t('errors.invalidEmail')).required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t(
        'materialityAssessment.fields.contactEmail',
        { interpolation: { escapeValue: false } },
      ),
      interpolation: { escapeValue: false },
    },
  )),
  [INTERNAL_LIAISON]: yup.string().min(COMPANY_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('materialityAssessment.fields.internalLiaison'), length: COMPANY_NAME_MIN_LENGTH },
  )).max(DATA_SETS_NAME_MAX_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('materialityAssessment.fields.internalLiaison'), length: DATA_SETS_NAME_MAX_LENGTH },
  )).required(i18next.t('errors.requiredField', { name: i18next.t('materialityAssessment.fields.internalLiaison') }))
    .transform(
      (value) => value.trim(),
    )
    .trim(),
  [INTERNAL_LIAISON_EMAIL]: yup.string().email(i18next.t('errors.invalidEmail')).required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t(
        'materialityAssessment.fields.internalLiaisonEmail',
        { interpolation: { escapeValue: false } },
      ),
      interpolation: { escapeValue: false },
    },
  )),
});

export type TMediaCreateSchema = yup.InferType<typeof mediaCreateSchema>;

export const NGOCreateSchema = yup.object({
  [NGO_NAME]: yup.string().min(COMPANY_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('materialityAssessment.fields.ngoName'), length: COMPANY_NAME_MIN_LENGTH },
  )).max(DATA_SETS_NAME_MAX_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('materialityAssessment.fields.ngoName'), length: DATA_SETS_NAME_MAX_LENGTH },
  )).required(i18next.t(
    'errors.requiredField',
    { name: i18next.t('materialityAssessment.fields.ngoName') },
  ))
    .transform(
      (value) => value.trim(),
    )
    .trim(),
  [REPRESENTATION_CATEGORY]: yup.object().shape({
    label: yup.string().required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t(
          'materialityAssessment.fields.representationCategory',
          { interpolation: { escapeValue: false } },
        ),
        interpolation: { escapeValue: false },
      },
    )),
    value: yup.string().required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t(
          'materialityAssessment.fields.representationCategory',
          { interpolation: { escapeValue: false } },
        ),
        interpolation: { escapeValue: false },
      },
    )),
  }).required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t(
        'materialityAssessment.fields.representationCategory',
        { interpolation: { escapeValue: false } },
      ),
      interpolation: { escapeValue: false },
    },
  )),
  [RELEVANCE_TO_COMPANY]: yup.string().min(COMPANY_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('materialityAssessment.fields.relevanceToCompany'), length: COMPANY_NAME_MIN_LENGTH },
  )).max(DESCRIPTION_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('materialityAssessment.fields.relevanceToCompany'), length: DESCRIPTION_LENGTH },
  )).required(i18next.t('errors.requiredField', { name: i18next.t('materialityAssessment.fields.relevanceToCompany') }))
    .transform(
      (value) => value.trim(),
    )
    .trim(),
  [NGO_CONTACT_NAME]: yup.string().required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t(
        'materialityAssessment.fields.ngoContactName',
        { interpolation: { escapeValue: false } },
      ),
      interpolation: { escapeValue: false },
    },
  )),
  [NGO_CONTACT_EMAIL]: yup.string().email(i18next.t('errors.invalidEmail')).required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t(
        'materialityAssessment.fields.ngoContactEmail',
        { interpolation: { escapeValue: false } },
      ),
      interpolation: { escapeValue: false },
    },
  )),
  [INTERNAL_LIAISON]: yup.string().min(COMPANY_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('materialityAssessment.fields.internalLiaison'), length: COMPANY_NAME_MIN_LENGTH },
  )).max(DATA_SETS_NAME_MAX_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('materialityAssessment.fields.internalLiaison'), length: DATA_SETS_NAME_MAX_LENGTH },
  )).required(i18next.t('errors.requiredField', { name: i18next.t('materialityAssessment.fields.internalLiaison') }))
    .transform(
      (value) => value.trim(),
    )
    .trim(),
  [INTERNAL_LIAISON_EMAIL]: yup.string().email(i18next.t('errors.invalidEmail')).required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t(
        'materialityAssessment.fields.internalLiaisonEmail',
        { interpolation: { escapeValue: false } },
      ),
      interpolation: { escapeValue: false },
    },
  )),
});

export type TNGOCreateSchema = yup.InferType<typeof NGOCreateSchema>;

export const tableCheckboxSchema = yup.object({
  [SELECTED_ITEMS]: yup.array().of(yup.number().required()).required(),
  [SELECT_ALL]: yup.string(),
  [STATUS]: yup.array().of(yup.string()),
  [SEARCH]: yup.string(),
});

export type TTableCheckboxSchema = yup.InferType<typeof tableCheckboxSchema>;

export const questionCreateSchema = yup.object({
  [QUESTION]: yup.string().min(COMPANY_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('materialityAssessment.fields.question'), length: COMPANY_NAME_MIN_LENGTH },
  )).max(DESCRIPTION_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('materialityAssessment.fields.question'), length: DESCRIPTION_LENGTH },
  )).required(i18next.t('errors.requiredField', { name: i18next.t('materialityAssessment.fields.question') }))
    .transform(
      (value) => value.trim(),
    )
    .trim(),
  [COMPANY_NAME]: yup.string().min(COMPANY_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('materialityAssessment.fields.companyName'), length: COMPANY_NAME_MIN_LENGTH },
  )).max(DESCRIPTION_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('materialityAssessment.fields.companyName'), length: DESCRIPTION_LENGTH },
  )).required(i18next.t('errors.requiredField', { name: i18next.t('materialityAssessment.fields.companyName') }))
    .transform(
      (value) => value.trim(),
    )
    .trim(),
  [SOURCE]: yup.string()
    .transform((value) => value?.trim() || '')
    .min(COMPANY_NAME_MIN_LENGTH, i18next.t(
      'errors.minCharactersLength',
      { name: i18next.t('materialityAssessment.fields.source'), length: COMPANY_NAME_MIN_LENGTH },
    ))
    .max(DESCRIPTION_LENGTH, i18next.t(
      'errors.maxCharactersLength',
      { name: i18next.t('materialityAssessment.fields.source'), length: DESCRIPTION_LENGTH },
    ))
    .required(i18next.t('errors.requiredField', { name: i18next.t('materialityAssessment.fields.source') }))
    .trim(),
  [QUESTION_TYPE]: createObjectShapeValidation('materialityAssessment.fields.questionType'),
  [QUESTION_SOURCE_TYPE]: createObjectShapeValidation('materialityAssessment.fields.questionSourceType'),
});

export type TQuestionCreateSchema = yup.InferType<typeof questionCreateSchema>;

export const disclosuresCreateSchema = yup.object({
  [DISCLOSURE]: yup.string().min(COMPANY_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('materialityAssessment.fields.disclosure'), length: COMPANY_NAME_MIN_LENGTH },
  )).max(DESCRIPTION_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('materialityAssessment.fields.disclosure'), length: DESCRIPTION_LENGTH },
  )).required(i18next.t('errors.requiredField', { name: i18next.t('materialityAssessment.fields.disclosure') }))
    .transform(
      (value) => value.trim(),
    )
    .trim(),
  [REQUIRED_BY]: yup.string().min(COMPANY_NAME_MIN_LENGTH, i18next.t(
    'errors.minCharactersLength',
    { name: i18next.t('materialityAssessment.fields.requiredBy'), length: COMPANY_NAME_MIN_LENGTH },
  )).max(DATA_SETS_NAME_MAX_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('materialityAssessment.fields.requiredBy'), length: DATA_SETS_NAME_MAX_LENGTH },
  )).required(i18next.t('errors.requiredField', { name: i18next.t('materialityAssessment.fields.requiredBy') }))
    .transform(
      (value) => value.trim(),
    )
    .trim(),
  [SOURCE]: yup.string()
    .transform((value) => value?.trim() || undefined)
    .notRequired()
    .min(COMPANY_NAME_MIN_LENGTH, i18next.t(
      'errors.minCharactersLength',
      { name: i18next.t('materialityAssessment.fields.source'), length: COMPANY_NAME_MIN_LENGTH },
    ))
    .max(DATA_SETS_NAME_MAX_LENGTH, i18next.t(
      'errors.maxCharactersLength',
      { name: i18next.t('materialityAssessment.fields.source'), length: DATA_SETS_NAME_MAX_LENGTH },
    )),
  [CATEGORY]: createObjectShapeValidation('materialityAssessment.fields.category'),
  [COUNTRY]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).test('not-empty', i18next.t('errors.requiredField', {
    name: i18next.t('materialityAssessment.fields.country', { interpolation: { escapeValue: false } }),
    interpolation: { escapeValue: false },
  }), (obj) => {
    if (!obj) return false;
    return !(obj.value === '' && obj.label === '');
  }).default(undefined)
    .required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t(
          'materialityAssessment.fields.country',
          { interpolation: { escapeValue: false } },
        ),
        interpolation: { escapeValue: false },
      },
    )),
});

export type TDisclosuresCreateSchema = yup.InferType<typeof disclosuresCreateSchema>;

export const competitorCreateSchema = yup.object({
  [COMPANY_NAME]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).test('not-empty', i18next.t('errors.requiredField', {
    name: i18next.t('materialityAssessment.fields.companyName', { interpolation: { escapeValue: false } }),
    interpolation: { escapeValue: false },
  }), (obj) => {
    if (!obj) return false;
    return !(obj.value === '' && obj.label === '');
  }).default(undefined)
    .required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t(
          'materialityAssessment.fields.companyName',
          { interpolation: { escapeValue: false } },
        ),
        interpolation: { escapeValue: false },
      },
    )),
  [STOCK_TICKER]: yup.array().of(yup.object().shape({
    label: yup.string().required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t('materialityAssessment.fields.stockTicker', { interpolation: { escapeValue: false } }),
        interpolation: { escapeValue: false },
      },
    )),
    value: yup.string().required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t('materialityAssessment.fields.stockTicker', { interpolation: { escapeValue: false } }),
        interpolation: { escapeValue: false },
      },
    )),
  })).test('not-empty-array-if-exists', i18next.t('errors.requiredField', {
    name: i18next.t('materialityAssessment.fields.stockTicker', { interpolation: { escapeValue: false } }),
    interpolation: { escapeValue: false },
  }), (value) => !value || value.length > 0),
  [WEBSITE]: yup.string().url(i18next.t('errors.invalidUrl')).required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t(
        'materialityAssessment.fields.website',
        { interpolation: { escapeValue: false } },
      ),
      interpolation: { escapeValue: false },
    },
  )),
  [SECTOR]: yup.array().of(yup.object().shape({
    label: yup.string().required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t('materialityAssessment.fields.sector', { interpolation: { escapeValue: false } }),
        interpolation: { escapeValue: false },
      },
    )),
    value: yup.string().required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t('materialityAssessment.fields.sector', { interpolation: { escapeValue: false } }),
        interpolation: { escapeValue: false },
      },
    )),
  })).test('not-empty-array-if-exists', i18next.t('errors.requiredField', {
    name: i18next.t('materialityAssessment.fields.sector', { interpolation: { escapeValue: false } }),
    interpolation: { escapeValue: false },
  }), (value) => !value || value.length > 0),
  [SEER_COMPETITOR]: yup.object().shape({
    label: yup.string().required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t('materialityAssessment.fields.seerCompetitor', { interpolation: { escapeValue: false } }),
        interpolation: { escapeValue: false },
      },
    )),
    value: yup.string().required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t('materialityAssessment.fields.seerCompetitor', { interpolation: { escapeValue: false } }),
        interpolation: { escapeValue: false },
      },
    )),
  }).required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t(
        'materialityAssessment.fields.seerCompetitor',
        { interpolation: { escapeValue: false } },
      ),
      interpolation: { escapeValue: false },
    },
  )),
  [SIZE_MIN]: yup.string().required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t(
        'materialityAssessment.fields.sizeEmployees',
        { interpolation: { escapeValue: false } },
      ),
      interpolation: { escapeValue: false },
    },
  )),
  [SIZE_MAX]: yup.string().required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t(
        'materialityAssessment.fields.sizeEmployees',
        { interpolation: { escapeValue: false } },
      ),
      interpolation: { escapeValue: false },
    },
  )),
});

export type TCompetitorCreateSchema = yup.InferType<typeof competitorCreateSchema>;

export const dataMAListSchema = yup.object({
  [SEARCH]: yup.string(),
  [SORT]: yup.object().shape({
    [ORDER_KEY]: yup.string(),
    [ORDER_TYPE]: yup.string<TOrders>(),
  }),
  [RELATE_TO]: yup.array().of(yup.string()),
  [STATUS]: yup.array().of(yup.string()),
});

export type TDataMAListSchema = yup.InferType<typeof dataMAListSchema>;

export const geographicCreateSchema = yup.object({
  [ADDRESS_COUNTRY]: createLabelValueObjectSchema('materialityAssessment.fields.country'),
  [CATEGORY]: createLabelValueObjectSchema('materialityAssessment.fields.category').default(undefined),
  [ADDRESS_STATE]: yup.array().of(createLabelValueObjectSchema('materialityAssessment.fields.state'))
    .min(1, i18next.t('errors.requiredField', {
      name: i18next.t('materialityAssessment.fields.state', { interpolation: { escapeValue: false } }),
      interpolation: { escapeValue: false },
    }))
    .required(i18next.t('errors.requiredField', {
      name: i18next.t('materialityAssessment.fields.state', { interpolation: { escapeValue: false } }),
      interpolation: { escapeValue: false },
    })),
  [SPECIFIC_SENSITIVITY]: createLabelValueObjectSchema('materialityAssessment.fields.specificSensitivity'),
  [SOURCE]: yup.array().of(createLabelValueObjectSchema('materialityAssessment.fields.source'))
    .min(1, i18next.t('errors.requiredField', {
      name: i18next.t('materialityAssessment.fields.source', { interpolation: { escapeValue: false } }),
      interpolation: { escapeValue: false },
    }))
    .required(i18next.t('errors.requiredField', {
      name: i18next.t('materialityAssessment.fields.source', { interpolation: { escapeValue: false } }),
      interpolation: { escapeValue: false },
    })),
});

export type TGeographicCreateSchema = yup.InferType<typeof geographicCreateSchema>;

export const sourceLinkCreateSchema = yup.object({
  [NAME]: yup.string()
    .required()
    .min(2, i18next.t('errors.minLength', {
      name: i18next.t('materialityAssessment.fields.name'),
      min: COMPANY_NAME_MIN_LENGTH,
    })),
  [SOURCE]: yup.string()
    .required()
    .min(2, i18next.t('errors.minLength', {
      name: i18next.t('materialityAssessment.fields.source'),
      min: COMPANY_NAME_MIN_LENGTH,
    })),
});

export type TSourceLinkCreateSchema = yup.InferType<typeof sourceLinkCreateSchema>;

export const specificCreateSchema = yup.object({
  [ADDRESS_COUNTRY]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).test('not-empty', i18next.t('errors.requiredField', {
    name: i18next.t('materialityAssessment.fields.country', { interpolation: { escapeValue: false } }),
    interpolation: { escapeValue: false },
  }), (obj) => {
    if (!obj) return false;
    return !(obj.value === '' && obj.label === '');
  }).required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t('materialityAssessment.fields.country', { interpolation: { escapeValue: false } }),
      interpolation: { escapeValue: false },
    },
  )),
  [INDUSTRY_CODE]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).test(createNotEmptyObjectTest('materialityAssessment.fields.industryCode')).required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t('materialityAssessment.fields.industryCode', { interpolation: { escapeValue: false } }),
      interpolation: { escapeValue: false },
    },
  )),
  [SECTOR_CODE]: yup.array().of(yup.object().shape({
    label: yup.string()
      .required()
      .min(1, i18next.t('errors.requiredField', {
        name: i18next.t('materialityAssessment.fields.sectorCode'),
      })),
    value: yup.string()
      .required()
      .min(1, i18next.t('errors.requiredField', {
        name: i18next.t('materialityAssessment.fields.sectorCode'),
      })),
  }).test(createNotEmptyObjectTest('materialityAssessment.fields.sectorCode')).required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t('materialityAssessment.fields.sectorCode', { interpolation: { escapeValue: false } }),
      interpolation: { escapeValue: false },
    },
  )))
    .min(1, i18next.t('errors.requiredField', {
      name: i18next.t('materialityAssessment.fields.sectorCode', { interpolation: { escapeValue: false } }),
      interpolation: { escapeValue: false },
    }))
    .required(i18next.t('errors.requiredField', {
      name: i18next.t('materialityAssessment.fields.sectorCode', { interpolation: { escapeValue: false } }),
      interpolation: { escapeValue: false },
    })),

});

export type TSpecificCreateSchema = yup.InferType<typeof specificCreateSchema>;

export const selectItemSchema = yup.object({
  [SELECT_ITEM]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).test(createNotEmptyObjectTest()).required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t('common.', { interpolation: { escapeValue: false } }),
      interpolation: { escapeValue: false },
    },
  )),
});

export type TSelectItemSchema = yup.InferType<typeof selectItemSchema>;

export const topicCreateSchema = yup.object({
  [NACE_CODE]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).test(createNotEmptyObjectTest('standards.fields.nacaCode')).required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t('standards.fields.nacaCode', { interpolation: { escapeValue: false } }),
      interpolation: { escapeValue: false },
    },
  )),
  [TOPIC]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).test(createNotEmptyObjectTest('standards.fields.topic')).required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t('standards.fields.topic', { interpolation: { escapeValue: false } }),
      interpolation: { escapeValue: false },
    },
  )),
  [DESCRIPTION]: yup.string().max(DESCRIPTION_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('standards.fields.description'), length: DESCRIPTION_LENGTH },
  )),
  [STATUS]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).test(createNotEmptyObjectTest('standards.fields.status')).required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t('standards.fields.status', { interpolation: { escapeValue: false } }),
      interpolation: { escapeValue: false },
    },
  )),
});

export type TTopicCreateSchema = yup.InferType<typeof topicCreateSchema>;

export const updateAnalysisSchema = yup.object({
  [COMPANY_NAME]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).test('not-empty', i18next.t('errors.requiredField', {
    name: i18next.t('materialityAssessment.fields.companyName', { interpolation: { escapeValue: false } }),
    interpolation: { escapeValue: false },
  }), (obj) => {
    if (!obj) return false;
    return !(obj.value === '' && obj.label === '');
  }).default(undefined)
    .required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t(
          'materialityAssessment.fields.companyName',
          { interpolation: { escapeValue: false } },
        ),
        interpolation: { escapeValue: false },
      },
    )),
  [STOCK_TICKER]: yup.array().of(yup.object().shape({
    label: yup.string().required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t('materialityAssessment.fields.stockTicker', { interpolation: { escapeValue: false } }),
        interpolation: { escapeValue: false },
      },
    )),
    value: yup.string().required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t('materialityAssessment.fields.stockTicker', { interpolation: { escapeValue: false } }),
        interpolation: { escapeValue: false },
      },
    )),
  })).test('not-empty-array-if-exists', i18next.t('errors.requiredField', {
    name: i18next.t('materialityAssessment.fields.stockTicker', { interpolation: { escapeValue: false } }),
    interpolation: { escapeValue: false },
  }), (value) => !value || value.length > 0),
  [WEBSITE]: yup.string().url(i18next.t('errors.invalidUrl')).required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t(
        'materialityAssessment.fields.website',
        { interpolation: { escapeValue: false } },
      ),
      interpolation: { escapeValue: false },
    },
  )),
  [SECTOR]: yup.array().of(yup.object().shape({
    label: yup.string().required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t('materialityAssessment.fields.sector', { interpolation: { escapeValue: false } }),
        interpolation: { escapeValue: false },
      },
    )),
    value: yup.string().required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t('materialityAssessment.fields.sector', { interpolation: { escapeValue: false } }),
        interpolation: { escapeValue: false },
      },
    )),
  })).test('not-empty-array-if-exists', i18next.t('errors.requiredField', {
    name: i18next.t('materialityAssessment.fields.sector', { interpolation: { escapeValue: false } }),
    interpolation: { escapeValue: false },
  }), (value) => !value || value.length > 0),
  [SIZE_MAX]: yup.string().required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t(
        'materialityAssessment.fields.sizeEmployees',
        { interpolation: { escapeValue: false } },
      ),
      interpolation: { escapeValue: false },
    },
  )).matches(INTEGER_NUMBER_REGEX, {
    message: i18next.t('errors.onlyNumbers'),
    excludeEmptyString: true,
  }),
  [SUPPLIERS_EXPENSES]: yup.string().required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t(
        'materialityAssessment.fields.supplierExpenses',
        { interpolation: { escapeValue: false } },
      ),
      interpolation: { escapeValue: false },
    },
  )),
  [PURCHASE_VOLUME]: yup.string().required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t(
        'materialityAssessment.fields.purchaseVolume',
        { interpolation: { escapeValue: false } },
      ),
      interpolation: { escapeValue: false },
    },
  )),
  [PROFIT]: yup.string().required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t(
        'materialityAssessment.fields.profit',
        { interpolation: { escapeValue: false } },
      ),
      interpolation: { escapeValue: false },
    },
  )),
  [ADDRESS_COUNTRY]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).test('not-empty', i18next.t('errors.requiredField', {
    name: i18next.t('profitCentres.createProfitCentre.fields.country', { interpolation: { escapeValue: false } }),
    interpolation: { escapeValue: false },
  }), (obj) => {
    if (!obj) return false;
    return !(obj.value === '' && obj.label === '');
  }).default(undefined)
    .required(i18next.t(
      'errors.requiredField',
      {
        name: i18next.t('profitCentres.createProfitCentre.fields.country', { interpolation: { escapeValue: false } }),
        interpolation: { escapeValue: false },
      },
    )),
});

export type TUpdateAnalysisSchema = yup.InferType<typeof updateAnalysisSchema>;

export const iroCustomCreateSchema = yup.object({
  [NACE_SECTION]: createNaceSectionValidation('materialityAssessment.fields.naceSector'),
  [NACE_CODE]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).test(createNotEmptyObjectTest('materialityAssessment.fields.naceCode')).required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t('materialityAssessment.fields.naceCode', { interpolation: { escapeValue: false } }),
      interpolation: { escapeValue: false },
    },
  )),
  [REPORTING_FRAMEWORK]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).test(createNotEmptyObjectTest('materialityAssessment.fields.reportingFramework')).required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t('materialityAssessment.fields.reportingFramework', { interpolation: { escapeValue: false } }),
      interpolation: { escapeValue: false },
    },
  )),
  [IRO_CATEGORY]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).test(createNotEmptyObjectTest('materialityAssessment.fields.iroCategory')).required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t('materialityAssessment.fields.iroCategory', { interpolation: { escapeValue: false } }),
      interpolation: { escapeValue: false },
    },
  )),
  [IMPACT_STATUS]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).test(createNotEmptyObjectTest('materialityAssessment.fields.impactStatus')).required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t('materialityAssessment.fields.impactStatus', { interpolation: { escapeValue: false } }),
      interpolation: { escapeValue: false },
    },
  )),
  [POSITION_ON_VALUE_CHAINS]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).test(createNotEmptyObjectTest('materialityAssessment.fields.positionOnValueChains')).required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t('materialityAssessment.fields.positionOnValueChains', { interpolation: { escapeValue: false } }),
      interpolation: { escapeValue: false },
    },
  )),
  [IRO_DESCRIPTION]: yup.string().required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t(
        'materialityAssessment.fields.iroDescription',
        { interpolation: { escapeValue: false } },
      ),
      interpolation: { escapeValue: false },
    },
  )).max(TASK_DESCRIPTION_MIN_LENGTH, i18next.t(
    'errors.maxCharactersLength',
    { name: i18next.t('materialityAssessment.fields.iroDescription'), length: TASK_DESCRIPTION_MIN_LENGTH },
  )),
  [TOPIC]: yup.object().shape({
    label: yup.string(),
    value: yup.string(),
  }).test(createNotEmptyObjectTest('materialityAssessment.fields.topic')).required(i18next.t(
    'errors.requiredField',
    {
      name: i18next.t('materialityAssessment.fields.topic', { interpolation: { escapeValue: false } }),
      interpolation: { escapeValue: false },
    },
  )),
});

export type TROCustomCreateSchema = yup.InferType<typeof iroCustomCreateSchema>;

export const createSupplierVCSchema = createSupplierSchema.concat(
  yup.object({
    [ESTIMATED]: yup.object().shape({
      label: yup.string(),
      value: yup.string().required(i18next.t(
        'errors.requiredField',
        { name: i18next.t('suppliers.fields.estimated') },
      )),
    }),
  }),
);

export type TCreateSupplierVCSchema = yup.InferType<typeof createSupplierVCSchema>;

export const VCFormSchema = yup.object({
  [VALUE_CHAIN_MAPS]: yup.array().of(yup.object().shape({
    id: yup.number(),
    name: yup.string(),
    status: yup.string(),
    createdBy: yup.object().shape({
      id: yup.number(),
      firstName: yup.string(),
      lastName: yup.string(),
    }),
    updatedBy: yup.object().shape({
      id: yup.number(),
      firstName: yup.string(),
      lastName: yup.string(),
    }),
    createdAt: yup.string(),
    updatedAt: yup.string(),
  })),
});

export type TVCFormSchema = yup.InferType<typeof VCFormSchema>;

export const addUserModalSchema = yup.object({
  [CONTACT_EMAIL]: yup.string().email(i18next.t('errors.invalidEmail'))
    .required(i18next.t('errors.requiredField', {
      name: i18next.t('materialityAssessment.fields.contactEmail'),
      interpolation: { escapeValue: false },
    })),
  [CONTACT_NAME]: yup.string()
    .transform((value) => (value ? value.trim() : undefined))
    .nullable()
    .notRequired()
    .min(COMPANY_NAME_MIN_LENGTH, i18next.t(
      'errors.minCharactersLength',
      { name: i18next.t('materialityAssessment.fields.name'), length: COMPANY_NAME_MIN_LENGTH },
    ))
    .max(DATA_SETS_NAME_MAX_LENGTH, i18next.t(
      'errors.maxCharactersLength',
      { name: i18next.t('materialityAssessment.fields.name'), length: DATA_SETS_NAME_MAX_LENGTH },
    )),
  [RESPONDENT_TYPE]: yup.object().shape({
    label: yup.string(),
    value: yup.string().required(i18next.t(
      'errors.requiredField',
      { name: i18next.t('materialityAssessment.fields.respondentType') },
    )),
  }),
});

export type TAddUserModalSchema = yup.InferType<typeof addUserModalSchema>;

export const addScenarioFormSchema = yup.object({
  [NAME]: yup.string()
    .trim()
    .min(1, i18next.t('errors.minCharactersLength', { name: i18next.t('common.name'), length: 1 }))
    .max(100, i18next.t('errors.maxCharactersLength', { name: i18next.t('common.name'), length: 100 }))
    .required(i18next.t('errors.nameRequired')),
  [AFFECTED_PERIOD]: yup.number()
    .transform((value, originalValue) => (originalValue === '' || originalValue == null ? undefined : value))
    .typeError(i18next.t('errors.requiredField', { name: i18next.t('valueChainMap.affectedPeriodLabel') }))
    .required(i18next.t('errors.requiredField', { name: i18next.t('valueChainMap.affectedPeriodLabel') }))
    .min(1, i18next.t('errors.minNumber', {
      name: i18next.t('valueChainMap.affectedPeriodLabel'),
      min: 1,
    })),
  [AFFECTED_PERIOD_UNIT]: yup.object({
    label: yup.string().required(),
    value: yup.string().required(),
  }).required(i18next.t('errors.requiredField', { name: 'Period Unit' })),
  [PRODUCTIVITY_IMPACT]: yup.number()
    .transform((value, originalValue) => (originalValue === '' || originalValue == null ? undefined : value))
    .typeError(i18next.t('errors.requiredField', { name: 'Productivity Impact' }))
    .required(i18next.t('errors.requiredField', { name: 'Productivity Impact' }))
    .test(
      'productivity-impact-range',
      'Productivity Impact must be between 1 and 100',
      (value) => value == null || (value <= -1 && value >= -100),
    ),
  [UNIT_IDS]: yup.array()
    .of(yup.number().required())
    .min(1, i18next.t('errors.requiredField', {
      name: i18next.t('valueChainMap.affectedEntitiesLabel'),
    }))
    .required(i18next.t('errors.requiredField', {
      name: i18next.t('valueChainMap.affectedEntitiesLabel'),
    })),
});

export type TAddScenarioFormSchema = yup.InferType<typeof addScenarioFormSchema>;
